const lang = {
  'Animations': 'Animations',
  'AttachAlbum': 'Album',
  'Appearance.Color.Hex': 'HEX',
  'Appearance.Color.RGB': 'RGB',
  'BlockModal.Search.Placeholder': 'Block user...',
  'DarkMode': 'Dark Mode',
  'FilterIncludeExcludeInfo': 'Choose chats and types of chats that will\nappear and never appear in this folder.',
  'FilterMenuDelete': 'Delete Folder',
  'FilterHeaderEdit': 'Edit Folder',
  'FilterAllGroups': 'All Groups',
  'FilterAllContacts': 'All Contacts',
  'FilterAllNonContacts': 'All Non-Contacts',
  'FilterAllChannels': 'All Channels',
  'FilterAllBots': 'All Bots',
  'FilterPersonal': 'Personal',
  'EditContact.OriginalName': 'original name',
  'EditProfile.FirstNameLabel': 'Name',
  'EditProfile.BioLabel': 'Bio (optional)',
  'EditProfile.Username.Label': 'Username (optional)',
  'EditProfile.Username.Available': 'Username is available',
  'EditProfile.Username.Taken': 'Username is already taken',
  'EditProfile.Username.Invalid': 'Username is invalid',
  'EditFolder.Toast.ChooseChat': 'Please choose at least one chat for this folder.',
  'EditBot.Title': 'Edit Bot',
  'EditBot.Username.Caption': 'This username cannot be edited.',
  'EditBot.Buttons.Caption': 'Use [@BotFather](https://t.me/botfather) to manage this bot.',
  'EditBot.Buttons.Intro': 'Edit Intro',
  'EditBot.Buttons.Commands': 'Edit Commands',
  'EditBot.Buttons.Settings': 'Change Bot Settings',
  'ExceptionModal.Search.Placeholder': 'Add exception...',
  'SharedFolder.CreateLink': 'Create a New Link',
  'SharedFolder.Description': 'Give your friends and colleagues access to the entire folder including all of its groups and channels where you have the necessary rights.',
  'SharedFolder.Edit.Title': 'Share Folder',
  'SharedFolder.Edit.Description': 'Anyone with this link can add **%s** folder and the %s selected below',
  'SharedFolder.Edit.Subtitle': 'You can only share groups and channels in which you are allowed to create invite links.',
  'SharedFolder.Includes': 'Includes %s',
  'SharedFolder.Toast.NeedName': 'Shared folders must have a name.',
  'SharedFolder.Toast.NoTypes': 'Chat types are not supported in shared folders.',
  'SharedFolder.Toast.NoExcluded': 'Excluded chats are not supported in shared folders.',
  'SharedFolder.Toast.NoAdminChannel': 'You don\'t have the admin rights to share invite links to this channel.',
  'SharedFolder.Toast.NoAdminGroup': 'You don\'t have the admin rights to share invite links to this group chat.',
  'SharedFolder.Toast.NoPrivate': 'You can\'t share private chats.',
  'SharedFolder.Cant.ShareUsers': 'you can\'t share chats with users',
  'SharedFolder.Cant.ShareBots': 'you can\'t share chats with bots',
  'SharedFolder.Cant.Share': 'you can\'t invite others here',
  'SharedFolder.NoChats': 'There are no chats in this folder that you can share with others.',
  'SharedFolder.NoChats.Title': 'These chats cannot be shared',
  'SharedFolder.Link.Expired': 'The folder link has expired.',
  'SharedFolder.Link.Title': 'Add Folder',
  'SharedFolder.Link.TitleAdd': 'Add Chats to Folder',
  'SharedFolder.Link.TitleRemove': 'Remove Folder',
  'SharedFolder.Link.Description': 'Do you want to add a new chat folder and join its groups and channels?',
  'SharedFolder.Link.DescriptionAdd': 'Do you want to join **%s** and add them to your folder **%s**?',
  'SharedFolder.Link.DescriptionAlready': 'You have already added this folder and its chats.',
  'SharedFolder.Link.DescriptionRemove': 'Do you want to quit the chats you joined when adding the folder **%s**?',
  'SharedFolder.Link.Chats': '%s in folder to join',
  'SharedFolder.Link.ChatsAdd': '%s to join',
  'SharedFolder.Link.ChatsAlready': '%s in this folder',
  'SharedFolder.Link.ChatsRemove': '%s to quit',
  'SharedFolder.Link.Join': 'JOIN CHATS',
  'SharedFolder.Link.Remove': 'Remove Folder and Chats',
  'SharedFolder.Link.ChatAlready': 'you are already a member',
  'SharedFolder.Link.ChannelAlready': 'you are already subscribed',
  'Chat.Menu.SelectMessages': 'Select Messages',
  'Chat.Menu.ClearSelection': 'Clear Selection',
  'Chat.Menu.Hint': 'To **edit** or **reply**, close this menu.\nThen tap next to a message.',
  'Chat.Input.UnpinAll': 'Unpin All Messages',
  'Chat.Input.Attach.PhotoOrVideo': 'Photo or Video',
  'Chat.Input.Attach.Document': 'Document',
  'Chat.Subscribe': 'SUBSCRIBE',
  'Chat.Selection.LimitToast': 'Max selection count reached.',
  'Chat.Search.MessagesFound': {
    'one_value': '%d message found',
    'other_value': '%d messages found'
  },
  'Chat.Search.NoMessagesFound': 'No messages found',
  'Chat.Search.PrivateSearch': 'Private Search',
  'Chat.Service.TopicEdited.Mixed': '%1$@ changed the topic name and icon to %2$@',
  'Chat.Service.TopicEdited.You.Mixed': 'You changed the topic name and icon to %2$@',
  'Chat.Service.TopicEdited.Mixed.IconRemoved': '%1$@ changed the topic name to "%1$@" and removed icon',
  'Chat.Service.TopicEdited.You.Mixed.IconRemoved': 'You changed the topic name to "%1$@" and removed icon',
  'ChatsNew': {
    'one_value': '%d new chat',
    'other_value': '%d new chats'
  },
  'ChatList.Main.EmptyPlaceholder.Title': 'Your chats will appear here',
  'ChatList.Main.EmptyPlaceholder.Subtitle': 'You have %s on Telegram',
  'ChatList.Main.EmptyPlaceholder.SubtitleNoContacts': 'Use Telegram app on your [Android](https://telegram.org/android) or [iOS](https://telegram.org/dl/ios) device to sync your contacts',
  // "ChatList.Menu.Archived": "Archived",
  'ChatList.Menu.SwitchTo.Webogram': 'Switch to Old Version',
  'ChatList.Menu.SwitchTo.A': 'Switch to A version',
  'ChatList.SharedFolder.Title': '**You can join %s**',
  'ChatList.SharedFolder.Subtitle': 'Click here to view them',
  'ChatMigration.From': 'Migrated from %s',
  'ChatMigration.To': 'Migrated to %s',
  'ConnectionStatus.ForceReconnect': 'reconnect now',
  'ConnectionStatus.ReconnectInPlain': 'Reconnect in %ds',
  'ConnectionStatus.ReconnectIn': 'Reconnect in %ds, %s',
  'ConnectionStatus.Reconnect': 'reconnect',
  'ConnectionStatus.Reconnecting': 'Reconnecting...',
  'ConnectionStatus.TimedOut': 'Request timed out, %s',
  'ConnectionStatus.Waiting': 'Waiting for network...',
  'Contacts.Count': {
    'one_value': '%d contact',
    'other_value': '%d contacts'
  },
  'Deactivated.Title': 'Too many tabs...',
  'Deactivated.Subtitle': 'Telegram supports only one active tab with the app.\nClick anywhere to continue using this tab.',
  'Deactivated.Version.Title': 'WebK has updated...',
  'Deactivated.Version.Subtitle': 'Another tab is running a newer version of Telegram.\nClick anywhere to reload this tab.',
  'Discussion.Set.PrivateChannel': 'Any member of this group will be able to see messages in the channel.',
  'Discussion.Set.PrivateGroup': 'Anyone from the channel will be able to see messages in this group.',
  // "Drafts": {
  //   "one_value": "%d draft",
  //   "other_value": "%d drafts",
  // },
  'General.Keyboard': 'Keyboard',
  'General.SendShortcut.Enter': 'Send by Enter',
  'General.SendShortcut.CtrlEnter': 'Send by %s + Enter',
  'General.SendShortcut.NewLine.ShiftEnter': 'New line by Shift + Enter',
  'General.SendShortcut.NewLine.Enter': 'New line by Enter',
  'General.TimeFormat': 'Time Format',
  'General.TimeFormat.h12': '12-hour',
  'General.TimeFormat.h23': '24-hour',
  'ChatBackground.UploadWallpaper': 'Upload Wallpaper',
  'ChatBackground.Blur': 'Blur Wallpaper Image',
  'InviteLinks.Additional': 'Additional Links',
  'InviteLinks.LimitReached': 'limit reached',
  'InviteLinks.Edit': 'Edit Link',
  'InviteLinks.ExpiresCaption': 'This link expires %s.',
  'InviteLinks.Reactivate': 'Reactivate Link',
  'Notifications.Sound': 'Notification Sound',
  'NewPrivateChat': 'New Private Chat',
  'NewPoll.OptionLabel': 'Option %d',
  'Message.Context.Selection.Copy': 'Copy selected',
  'Message.Context.Selection.Clear': 'Clear selection',
  'Message.Context.Selection.Delete': 'Delete selected',
  'Message.Context.Selection.Forward': 'Forward selected',
  'Message.Context.Selection.Download': 'Download selected',
  'Message.Context.Selection.SendNow': 'Send selected now',
  'Message.Unsupported.Desktop': '__This message is currently not supported on Telegram Web. Try [getdesktop.telegram.org](https://getdesktop.telegram.org/)__',
  'Message.Unsupported.Mobile': '__This message is currently not supported on Telegram Web. Try [telegram.org/dl](https://telegram.org/dl/)__',
  'Checkbox.Enabled': 'Enabled',
  'Checkbox.Disabled': 'Disabled',
  'Error.PreviewSender.CaptionTooLong': 'Caption is too long.',
  'PreviewSender.GroupItems': 'Group items',
  'PreviewSender.SendAlbum': {
    'one_value': 'Send Album',
    'other_value': 'Send %d Albums'
  },
  'Presence.YourChat': 'chat with yourself',
  'Privacy.Devices': {
    'one_value': '%1$d device',
    'other_value': '%1$d devices'
  },
  'Privacy.Websites': {
    'one_value': '%1$d website',
    'other_value': '%1$d websites'
  },
  'Privacy.SensitiveContent': 'Sensitive Content',
  'Privacy.Bio': 'Who can see my bio',
  'Privacy.BioCaption': 'You can restrict who can see your bio with granular precision.',
  'PrivacyModal.Search.Placeholder': 'Add Users or Groups...',
  'Permissions.NoExceptions': 'No exceptions',
  'Permissions.ExceptionsCount': {
    'one_value': '%d exception',
    'other_value': '%d exceptions'
  },
  'Permissions.RemoveFromGroup': 'Are you sure you want to remove **%s** from the group?',
  'PWA.Install': 'Install App',
  'Link.Available': 'Link is available',
  'Link.Taken': 'Link is already taken',
  'Link.Invalid': 'Link is invalid',
  'LiteMode.Key.chat.Title': 'Chat Animations',
  'LiteMode.Key.chat_background.Title': 'Wallpaper rotation',
  'LiteMode.Key.chat_spoilers.Title': 'Animated spoiler effect',
  'LiteMode.Key.stickers_panel.Title': 'Autoplay in panel',
  'LiteMode.Key.stickers_chat.Title': 'Autoplay in chat',
  'LiteMode.Key.emoji_panel.Title': 'Autoplay in panel',
  'LiteMode.Key.emoji_messages.Title': 'Autoplay in messages',
  'LiteMode.Key.effects.Title': 'Interactive Effects',
  'LiteMode.Key.effects_reactions.Title': 'Reaction effect',
  'LiteMode.Key.effects_premiumstickers.Title': 'Premium stickers effect',
  'LiteMode.Key.effects_emoji.Title': 'Emoji effect',
  'StickersTab.SearchPlaceholder': 'Search Stickers',
  'ForwardedFrom': 'Forwarded from %s',
  'ForwardedStoryFrom': 'Forwarded Story\nFrom: %s',
  'Popup.Avatar.Title': 'Drag to Reposition',
  'Popup.Unpin.AllTitle': 'Unpin all messages',
  'Popup.Unpin.HideTitle': 'Hide pinned messages',
  'Popup.Unpin.HideDescription': 'Do you want to hide the pinned message bar? It wil stay hidden until a new message is pinned.',
  'Popup.Unpin.Hide': 'Hide',
  'Popup.Attach.GroupMedia': 'Group all media',
  'Popup.Attach.UngroupMedia': 'Ungroup all media',
  'Popup.Attach.AsMedia': 'Send as media',
  'Popup.Attach.EnableSpoilers': 'Hide all with spoilers',
  'Popup.Attach.RemoveSpoilers': 'Remove all spoilers',
  'TwoStepAuth.EmailCodeChangeEmail': 'Change Email',
  'MarkupTooltip.LinkPlaceholder': 'Enter URL...',
  'MediaViewer.Context.Download': 'Download',
  'Profile': 'Profile',
  'Saved': 'Saved',
  'Deleted': 'Deleted',
  'ReportBug': 'Report Bug',
  'Notifications.Count': {
    'one_value': '%d notification',
    'other_value': '%d notifications'
  },
  'Notifications.Forwarded': {
    'one_value': 'Forwarded %d message',
    'other_value': 'Forwarded %d messages'
  },
  'Notifications.New': 'New notification',
  'PushNotification.Action.Mute1d': 'Mute background alerts for 1 day',
  'PushNotification.Action.Settings': 'Background alerts settings',
  'PushNotification.Action.Mute1d.Mobile': 'Mute for 1 day',
  'PushNotification.Action.Settings.Mobile': 'Alerts settings',
  'PushNotification.Message.NoPreview': 'You have a new message',
  'LogOut.Description': 'Are you sure you want to log out?\n\nNote that you can seamlessly use Telegram on all your devices at once.',
  // "PushNotification.Action.Mute1d.Success": "Notification settings were successfully saved.",
  // it is from iOS
  'VoiceChat.DiscussionGroup': 'discussion group',
  'PaymentInfo.CVV': 'CVV Code',
  'PaymentInfo.Card.Title': 'Enter your card information',
  'PaymentInfo.Billing.Title': 'Enter your billing address',
  'PaymentInfo.Done': 'PROCEED TO CHECKOUT',
  'PaymentCard.Error.Invalid': 'Invalid card number',
  'PaymentCard.Error.Incomplete': 'Incomplete card number',
  'LimitReached.Ok': 'OK, GOT IT',
  'Username.Purchase': '**This username is already taken.** However, it is currently available for purchase. [Learn more…]()',
  'Video.Unsupported.Desktop': '__Unfortunately, this video can\'t be played on Telegram Web. Try opening it with our [desktop app](https://getdesktop.telegram.org/) instead.__',
  'Video.Unsupported.Mobile': '__Unfortunately, this video can\'t be played on Telegram Web. Try opening it with our [mobile app](https://telegram.org/dl/) instead.__',
  'Error.RequestPeer.NoRights.Channel': 'Sorry, you can\'t add bots to this channel.',
  'Error.RequestPeer.NoRights.Group': 'Sorry, you can\'t add bots to this group.',
  'JustArgument': '%@',
  'Chat.Message.ViewApp': 'LAUNCH APP',
  'Alert.BotAppDoesntExist': 'Sorry, this application doesn\'t exist.',
  'ChatsSelected': {
    'one_value': '%d chat selected',
    'other_value': '%d chats selected'
  },
  'SelectAll': 'select all',
  'SearchPlaceholder': 'Search...',
  'DeselectAll': 'deselect all',
  'UsernamesBotHelp': 'Drag and drop links to change the order in which they will be displayed on the bot info page.',
  'UsernameActivateLinkBotMessage': 'Do you want to show this link on the bot info page?',
  'UsernameDeactivateLinkBotMessage': 'Do you want to hide this link from the bot info page?',
  'UsernameLinkBotUsername': 'bot username',
  'OpenChatlist': 'VIEW CHAT LIST',
  'RemoveSharedFolder': 'Are you sure you want to delete this folder? This will also deactivate all the invite links used to share this folder.',
  'OpenInNewTab': 'Open in new tab',
  'Story': 'Story',
  'Stories': 'Stories',
  'StoriesCount': {
    'one_value': '%1$d story',
    'other_value': '%1$d stories'
  },
  'ExpiredStory': 'Expired Story',
  'ExpiredStorySubtitle': 'From: %s',
  'ExpiredStoryMention': 'The story you were mentioned in is no longer available',
  'ExpiredStoryMentionYou': 'The story you mentioned %s in is no longer available',
  'YourStory': 'Your story',
  'MyStory': 'My Story',
  'PublicStories': 'Public Stories',
  'CloseFriendsTooltip': 'You are seeing this story because you have been added to %s\'s list of close friends.',
  'CloseFriendsTooltipYou': 'Only people from your close friends list will see this story.',
  'StoryMention': '%s mentioned you in a story',
  'StoryMentionYou': 'You mentioned %s in a story',
  'StoryMentionView': 'View Story',
  'StoryCantReply': 'You can\'t reply to this story',
  'MyStories.Title': 'My Stories',
  'MyStories.Archive': 'Archive',
  'MyStories.Subtitle': 'Only you can see archived stories unless you choose to save them to your profile.',
  'MyStories.ShowArchive': 'Show Archive',
  'Story.ReplyPlaceholder': 'Reply Privately...',
  'SecondsShortAgo': '%ds ago',
  'MinutesShortAgo': '%dm ago',
  'HoursShortAgo': '%dh ago',
  'DaysShortAgo': '%dd ago',
  'StoryJustNow': 'just now',
  'NoStoryFound': 'Sorry, this story doesn\'t seem to exist.',
  'OpenStory': 'OPEN STORY',
  'Story.AddToProfile': 'Post to Profile',
  'Story.RemoveFromProfile': 'Remove from Profile',
  'Story.NoSound': 'This video has no sound',
  'Story.ExpiredToast': 'This story is no longer available',
  'Story.ReportTitle': 'Report Story',
  'Story.SoundTooltip': 'Click here to enable sound.',
  'Popup.OpenInGoogleMaps': 'Open in Google Maps?',
  'WebApp.WriteAccess.Title': 'Allow Sending Messages',
  'WebApp.WriteAccess.Description': 'Allow %s to send messages?',
  'ActionBotAllowedRequest': 'You allowed this bot to message you when you accepted its request.',
  'WebApp.Disclaimer.Check': 'I agree to the **[Terms of Use]()**',
  'WebApp.AttachRemove.SuccessAll': '"%@" removed from all your menus.',
  'WebApp.AttachRemove.SuccessSide': '"%@" removed from your side menu.',

  // * android
  'AccDescrEditing': 'Editing',
  'ActionCreateChannel': 'Channel created',
  'ActionCreateGroup': 'un1 created the group',
  'ActionChangedTitle': 'un1 changed the group name to un2',
  'ActionRemovedPhoto': 'un1 removed the group photo',
  'ActionChangedPhoto': 'un1 changed the group photo',
  'ActionChangedVideo': 'un1 changed the group photo',
  'ActionAddUser': 'un1 added un2',
  'ActionAddUserSelf': 'un1 returned to the group',
  'ActionAddUserSelfYou': 'You returned to the group',
  'ActionAddUserSelfMega': 'un1 joined the group',
  'ActionLeftUser': 'un1 left the group',
  'ActionKickUser': 'un1 removed un2',
  'ActionInviteUser': 'un1 joined the group via invite link',
  'ActionPinnedNoText': 'un1 pinned a message',
  'ActionMigrateFromGroup': 'This group was upgraded to a supergroup',
  'ActionYouScored': 'You scored %1$s',
  'ActionUserScored': 'un1 scored %1$s',
  'ActionYouScoredInGame': 'You scored %1$s in un2',
  'ActionUserScoredInGame': 'un1 scored %1$s in un2',
  'AndOther': {
    'one_value': 'and %1$d other',
    'other_value': 'and %1$d others'
  },
  'AttachPhoto': 'Photo',
  'AttachVideo': 'Video',
  'AttachGif': 'GIF',
  'AttachLocation': 'Location',
  'AttachLiveLocation': 'Live Location',
  'AttachContact': 'Contact',
  // "AttachDocument": "File",
  'AttachSticker': 'Sticker',
  'AttachAudio': 'Voice message',
  'AttachRound': 'Video message',
  'AttachGame': 'Game',
  'Bot': 'bot',
  // "ChannelJoined": "You joined this channel",
  'ChannelMegaJoined': 'You joined this group',
  'EnterChannelName': 'Channel name',
  'DescriptionOptionalPlaceholder': 'Description (optional)',
  'DescriptionPlaceholder': 'Description',
  'DiscussionStarted': 'Discussion started',
  'Draft': 'Draft',
  'FilterAlwaysShow': 'Include Chats',
  'FilterNeverShow': 'Exclude Chats',
  'FilterInclude': 'Included Chats',
  'FilterExclude': 'Excluded Chats',
  'FilterChatTypes': 'Chat types',
  'FilterChats': 'Chats',
  'FilterNew': 'New Folder',
  'Filters': 'Folders',
  'FilterRecommended': 'Recommended Folders',
  'FilterShowMoreChats': {
    'one_value': 'Show %1$d More Chat',
    'other_value': 'Show %1$d More Chats'
  },
  'ForwardedMessageCount': {
    'one_value': 'Forwarded message',
    'other_value': '%1$d forwarded messages'
  },
  'FromYou': 'You',
  'Add': 'Add',
  'Chats': {
    'one_value': '%1$d chat',
    'other_value': '%1$d chats'
  },
  'Channels': {
    'one_value': '%1$d channel',
    'other_value': '%1$d channels'
  },
  'Comments': {
    'one_value': '%1$d Comment',
    'other_value': '%1$d Comments'
  },
  'Groups': {
    'one_value': '%1$d group',
    'other_value': '%1$d groups'
  },
  'Users': {
    'one_value': '%1$d user',
    'other_value': '%1$d users'
  },
  'Members': {
    'one_value': '%1$d member',
    'other_value': '%1$d members'
  },
  'messages': {
    'one_value': '%1$d message',
    'other_value': '%1$d messages'
  },
  'UsernameHelpLink': 'This link opens a chat with you:\n%1$s',
  'NewChannel': 'New Channel',
  'NewGroup': 'New Group',
  'Contacts': 'Contacts',
  'SavedMessages': 'Saved Messages',
  'Settings': 'Settings',
  'SettingsHelp': 'Help',
  'General': 'General',
  'TextSize': 'Message Text Size',
  'ChatBackground': 'Chat Wallpaper',
  'EnableAnimations': 'Enable Animations',
  'AutoDownloadMedia': 'Auto-Download Media',
  'AutodownloadContacts': 'Contacts',
  'AutodownloadPrivateChats': 'Private Chats',
  'AutodownloadGroupChats': 'Group Chats',
  'AutodownloadChannels': 'Channels',
  'AutoplayGIF': 'GIFs',
  'AutoplayVideo': 'Videos',
  'NotificationsForGroups': 'Notifications for groups',
  'NotificationsForPrivateChats': 'Notifications for private chats',
  'NotificationsForChannels': 'Notifications for channels',
  'NotificationsPrivateChats': 'Private Chats',
  'NotificationsGroups': 'Groups',
  'NotificationsChannels': 'Channels',
  'NotificationsOther': 'Other',
  'MarkAsUnread': 'Mark as unread',
  'MarkAsRead': 'Mark as read',
  'MarkAllAsRead': 'Mark all as read',
  'ContactJoined': 'Contact joined Telegram',
  'Loading': 'Loading...',
  'Unblock': 'Unblock',
  'BlockedUsers': 'Blocked Users',
  'BlockedUsersInfo': 'Blocked users can\'t send you messages or add you to groups. They will not see your profile photos, stories, online and last seen status.',
  'BlockedEmpty': 'None',
  'TwoStepVerification': 'Two-Step Verification',
  'TwoStepVerificationTitle': 'Two-Step Verification',
  'PinnedMessage': 'Pinned Message',
  'PinnedMessagesCount': {
    'one_value': 'Pinned Message',
    'other_value': '%1$d Pinned Messages'
  },
  // "PreviousPinnedMessage": "Previous Message",
  'PrivacyExceptions': 'Exceptions',
  'PrivacyLastSeen': 'Last Seen & Online',
  'PrivacySettings': 'Privacy and Security',
  'PrivacyTitle': 'Privacy',
  'PrivacyPhone': 'Phone Number',
  'PrivacyPhoneTitle': 'Who can see my phone number?',
  'PrivacyPhoneTitle2': 'Who can find me by my number?',
  'PrivacyPhoneInfo': 'Users who have your number saved in their contacts will also see it on Telegram.',
  'PrivacyPhoneInfo3': 'Users who add your number to their contacts will see it on Telegram only if they are your contacts.',
  'PrivacyProfilePhoto': 'Profile Photos',
  'PrivacyProfilePhotoTitle': 'Who can see my profile photos?',
  'PrivacyP2PHeader': 'Peer-to-Peer',
  'PrivacyForwardsTitle': 'Who can add a link to my account when forwarding my messages?',
  'Reminders': 'Reminders',
  'ScheduledMessages': 'Scheduled Messages',
  'LastSeenTitle': 'Who can see your Last Seen time?',
  'SessionsTitle': 'Active Sessions',
  'CurrentSession': 'This device',
  'TerminateAllSessions': 'Terminate All Other Sessions',
  'TerminateSessionText': 'Are you sure you want to terminate this session?',
  'OtherSessions': 'Active sessions',
  'AreYouSureDeleteSingleMessage': 'Are you sure you want to delete this message?',
  'AreYouSureDeleteFewMessages': 'Are you sure you want to delete these messages?',
  'AreYouSureDeleteSingleMessageMega': 'Are you sure you want to delete this message for everyone?',
  'AreYouSureDeleteFewMessagesMega': 'Are you sure you want to delete these messages for everyone?',
  'AreYouSureDeleteAndExitName': 'Are you sure you want to delete and leave the group **%1$s**?',
  'AreYouSureDeleteThisChatSavedMessages': 'Are you sure you want to delete **Saved Messages**?',
  'AreYouSureDeleteThisChatWithUser': 'Are you sure you want to delete the chat with **%1$s**?',
  'AreYouSureSessionTitle': 'Terminate session',
  'AreYouSureSessionsTitle': 'Terminate sessions',
  'AreYouSureSessions': 'Are you sure you want to terminate all other sessions?',
  'Terminate': 'Terminate',
  'WhoCanCallMe': 'Who can call me?',
  'WhoCanAddMe': 'Who can add me to group chats?',
  'ArchivedChats': 'Archived Chats',
  'Cancel': 'Cancel',
  'HistoryCleared': 'History was cleared',
  'Archive': 'Archive',
  'Unarchive': 'Unarchive',
  'Delete': 'Delete',
  'Reply': 'Reply',
  'Edit': 'Edit',
  'Forward': 'Forward',
  'CopyLink': 'Copy Link',
  'Copy': 'Copy',
  'Search': 'Search',
  'LinkCopied': 'Link copied to clipboard',
  'LinkCopiedPrivateInfo': 'This link will only work for members of this chat.',
  'GroupAddMembers': 'Add Members',
  'SendMessageTo': 'Add people...',
  // "SelectChat": "Select Chat",
  'JumpToDate': 'Jump to Date',
  'Caption': 'Caption',
  'Message': 'Message',
  'Poll': 'Poll',
  'SharedFilesTab2': 'Files',
  'SharedMediaTab2': 'Media',
  // "SharedMediaTabFull2": "Shared Media",
  // "SharedGroupsTab2": "Groups",
  'SharedLinksTab2': 'Links',
  'SharedMusicTab2': 'Music',
  'SharedVoiceTab2': 'Voice',
  // "SharedGIFsTab2": "GIFs",
  'NewPoll': 'New Poll',
  'PollOptions': 'Poll options',
  'AskAQuestion': 'Ask a Question',
  'AddAnExplanationInfo': 'Users will see this text after choosing the wrong answer, good for educational purposes.',
  'AccDescrQuizExplanation': 'Explanation',
  'PhoneCopied': 'Phone copied to clipboard',
  'UsernameCopied': 'Username copied to clipboard.',
  // "HashtagCopied": "Hashtag copied to clipboard.",
  'BioCopied': 'Bio copied to clipboard.',
  'UserBio': 'Bio',
  'Username': 'Username',
  'UsernameAlso': 'also %1$s',
  'UsernameHelp': 'You can choose a username on **Telegram**. If you do, people will be able to find you by this username and contact you without needing your phone number.\n\nYou can use **a–z**, **0–9** and underscores. Minimum length is **5** characters.',
  'Phone': 'Phone',
  'Notifications': 'Notifications',
  'AreYouSureDeleteContact': 'Are you sure you want to delete this contact?',
  'AreYouSureDeleteAndExit': 'Are you sure you want to delete and leave the group?',
  'AreYouSureDeleteAndExitChannel': 'Do you want to delete and leave the channel?',
  'DeleteContact': 'Delete contact',
  'GroupType': 'Group Type',
  'ChannelType': 'Channel Type',
  'TypePrivate': 'Private',
  'TypePublic': 'Public',
  'TypePrivateGroup': 'Private',
  'TypePublicGroup': 'Public',
  'GroupMembers': 'Members',
  'DeleteMega': 'Delete Group',
  'DeleteMegaMenu': 'Delete group',
  'DeleteAndExitButton': 'Delete and Leave Group',
  'ChannelDelete': 'Delete Channel',
  'ChannelDeleteMenu': 'Delete channel',
  'ChannelPermissions': 'Permissions',
  'ChannelPermissionsHeader': 'What can members of this group do?',
  'ChannelAddException': 'Add Exception',
  'ChannelBlockedUsers': 'Removed users',
  'NoBlockedUsers': 'No removed users',
  'UserRestrictions': 'User Permissions',
  'UserRestrictionsDisabled': 'This option is disabled for all members in Group Permissions',
  'UserRestrictionsCanDo': 'What can this user do?',
  'UserRestrictionsRead': 'Read Messages',
  'UserRestrictionsSend': 'Send Messages',
  'UserRestrictionsSendMedia': 'Send Media',
  'UserRestrictionsSendPolls': 'Send Polls',
  'UserRestrictionsSendStickers': 'Send Stickers and GIFs',
  'UserRestrictionsSendPhotos': 'Send Photos',
  'UserRestrictionsSendVideos': 'Send Videos',
  'UserRestrictionsSendMusic': 'Send Music',
  'UserRestrictionsSendFiles': 'Send Files',
  'UserRestrictionsSendVoices': 'Send Voice Messages',
  'UserRestrictionsSendRound': 'Send Video Messages',
  'UserRestrictionsEmbedLinks': 'Embed Links',
  'UserRestrictionsChangeInfo': 'Change Chat Info',
  'UserRestrictionsPinMessages': 'Pin Messages',
  'UserRestrictionsInviteUsers': 'Add Users',
  // "UserRestrictionsNoRead": "can't read",
  'UserRestrictionsNoSend': 'can\'t send messages',
  'UserRestrictionsNoSendMedia': 'no media',
  'UserRestrictionsNoSendPolls': 'no polls',
  'UserRestrictionsNoSendStickers': 'no stickers & GIFs',
  'UserRestrictionsNoSendPhotos': 'no photos',
  'UserRestrictionsNoSendVideos': 'no videos',
  'UserRestrictionsNoSendMusic': 'no music',
  'UserRestrictionsNoSendDocs': 'no files',
  'UserRestrictionsNoSendVoice': 'no voice',
  'UserRestrictionsNoSendRound': 'no video messages',
  'UserRestrictionsNoEmbedLinks': 'no embed links',
  'UserRestrictionsNoChangeInfo': 'can\'t change Info',
  'UserRestrictionsNoPinMessages': 'no pins',
  'UserRestrictionsNoInviteUsers': 'can\'t add users',
  'UserRestrictionsBlock': 'Ban and remove from group',
  'ChannelPublic': 'Public Channel',
  'MegaPublic': 'Public Group',
  // "MegaLocation": "Location-based Group",
  'ChannelPublicInfo': 'Public channels can be found in search, anyone can join them.',
  'MegaPublicInfo': 'Public groups can be found in search, chat history is available to everyone and anyone can join.',
  'ChannelPrivate': 'Private Channel',
  'MegaPrivate': 'Private Group',
  'ChannelPrivateInfo': 'Private channels can only be joined via an invite link.',
  'MegaPrivateInfo': 'Private groups can only be joined if you were invited or have an invite link.',
  'ChannelPrivateLinkHelp': 'People can join your channel by following this link. You can revoke the link any time.',
  'MegaPrivateLinkHelp': 'People can join your group by following this link. You can revoke the link any time.',
  'RevokeButton': 'Revoke',
  'RevokeLink': 'Revoke Link',
  'RevokeAlert': 'Are you sure you want to revoke this link? Once the link is revoked, no one will be able to join using it.',
  'SetUrlPlaceholder': 'Link',
  'Subscribers': {
    'one_value': '%1$d subscriber',
    'other_value': '%1$d subscribers'
  },
  'SearchGifsTitle': 'Search GIFs',
  'PinMessageAlert': 'Pin this message in the group?',
  'PinMessageAlertTitle': 'Pin message',
  'PinMessageAlertChannel': 'Do you want to pin this message in this channel?',
  'PinMessageAlertChat': 'Do you want to pin this message at the top of the chat?',
  'UnpinMessageAlertTitle': 'Unpin message',
  'UnpinMessageAlert': 'Do you want to unpin this message?',
  'PinNotify': 'Notify all members',
  'PinMessage': 'Pin',
  'UnpinMessage': 'Unpin',
  'PinAlsoFor': 'Also pin for %1$s',
  'DeleteMessagesTitle': 'Delete %1$s',
  'DeleteSingleMessagesTitle': 'Delete message',
  'DeleteMessagesOption': 'Unsend My Messages',
  'DeleteMessagesOptionAlso': 'Also delete for %1$s',
  'DeleteForAll': 'Delete for all members',
  'DeleteMessagesTextGroup': 'You can also delete the %1$s you sent from the inboxes of other group members by checking "Unsend my messages".',
  'LeaveChannel': 'Leave Channel',
  'LeaveChannelMenu': 'Leave channel',
  'ChannelLeaveAlertWithName': 'Are you sure you want to leave **%1$s**?',
  'LeaveMegaMenu': 'Leave group',
  'DeleteChatUser': 'Delete chat',
  'PleaseEnterCurrentPassword': 'Enter your password',
  'PleaseEnterFirstPassword': 'Enter a password',
  'PleaseReEnterPassword': 'Re-enter your password',
  'Continue': 'Continue',
  'YourEmailSkip': 'Skip',
  'YourEmailSkipWarning': 'Warning',
  'YourEmailSkipWarningText': 'No, seriously.\n\nIf you forget your password, you will lose access to your Telegram account. There will be no way to restore it.',
  'TurnPasswordOffQuestionTitle': 'Disable password',
  'TurnPasswordOffQuestion': 'Are you sure you want to disable your password?',
  'Disable': 'Disable',
  'TwoStepVerificationSetPassword': 'Set Password',
  'TwoStepVerificationPasswordSet': 'Password Set!',
  'TwoStepVerificationPasswordSetInfo': 'This password will be required when you log in on a new device in addition to the code you get in the SMS.',
  'TwoStepVerificationPasswordReturnSettings': 'Return to Settings',
  'RecoveryEmail': 'Recovery email',
  'RecoveryEmailTitle': 'Recovery Email',
  'ResendCode': 'Resend code',
  'PasswordAsHintError': 'Hint must be different from your password',
  'AddStickersCount': 'ADD %1$s',
  'RemoveStickersCount': 'REMOVE %1$s',
  'Stickers': {
    'one_value': '%1$d sticker',
    'other_value': '%1$d stickers'
  },
  'HidAccount': 'The account was hidden by the user',
  'TelegramFeatures': 'Telegram Features',
  'SetColor': 'Set a color',
  'Open': 'Open',
  'OpenUrlTitle': 'Open Link',
  'OpenUrlAlert2': 'Do you want to open %1$s?',
  'FilterNoChatsToDisplay': 'Folder is empty',
  'FilterNoChatsToDisplayInfo': 'No chats currently belong to this folder.',
  'SupportStatus': 'support',
  'Lately': 'last seen recently',
  'WithinAWeek': 'last seen within a week',
  'WithinAMonth': 'last seen within a month',
  'ALongTimeAgo': 'last seen a long time ago',
  'Online': 'online',
  'MessageScheduleSend': 'Send Now',
  'MessageScheduleEditTime': 'Reschedule',
  'YouLeft': 'You left this group',
  'Recent': 'Recent',
  'Of': '%1$d of %2$d',
  'NoResult': 'No results',
  'Updating': 'Updating...',
  'Emoji': 'Emoji',
  'AddContactTitle': 'Add Contact',
  'HiddenName': 'Deleted Account',
  'Seconds': {
    'one_value': '%1$d second',
    'other_value': '%1$d seconds'
  },
  'Minutes': {
    'one_value': '%1$d minute',
    'other_value': '%1$d minutes'
  },
  'Hours': {
    'one_value': '%1$d hour',
    'other_value': '%1$d hours'
  },
  'Days': {
    'one_value': '%1$d day',
    'other_value': '%1$d days'
  },
  'Weeks': {
    'one_value': '%1$d week',
    'other_value': '%1$d weeks'
  },
  'Months': {
    'one_value': '%1$d month',
    'other_value': '%1$d months'
  },
  'Years': {
    'one_value': '%1$d year',
    'other_value': '%1$d years'
  },
  'TodayAtFormattedWithToday': 'today at %1$s',
  'formatDateAtTime': '%1$s at %2$s',
  'JoinByPeekChannelTitle': 'Join Channel',
  'JoinByPeekGroupTitle': 'Join Group',
  'YouWereKicked': 'you were removed',
  'ViaBot': 'via',
  'InviteExpired': 'This invite link has expired.',
  'NoUsernameFound': 'There is no Telegram account with this username.',
  'PrivacyDeleteCloudDrafts': 'Delete All Cloud Drafts',
  'AreYouSureClearDraftsTitle': 'Delete cloud drafts',
  'AreYouSureClearDrafts': 'Are you sure you want to delete all cloud drafts?',
  'BotInfoTitle': 'What can this bot do?',
  'ChatYourSelf': 'forward here to save',
  'GroupEmptyTitle1': 'You created a **group**.',
  'GroupEmptyTitle2': 'Groups can have:',
  'GroupDescription1': 'Up to 200,000 members',
  'GroupDescription2': 'Persistent chat history',
  'GroupDescription3': 'Public links such as t.me/title',
  'GroupDescription4': 'Admins with different rights',
  'ChatYourSelfDescription1': 'Forward messages here to save them',
  'ChatYourSelfDescription2': 'Send media and files to store them',
  'ChatYourSelfDescription3': 'Access this chat from any device',
  'ChatYourSelfDescription4': 'Use search to quickly find things',
  'ChatYourSelfTitle': 'Your cloud storage',
  'ActionYouCreateGroup': 'You created the group',
  'NoMessages': 'No messages here yet...',
  'NoScheduledMessages': 'No scheduled messages here yet...',
  'NoMessagesGreetingsDescription': 'Send a message or tap the greeting below.',
  'InviteToGroupError': 'Sorry, you can\'t add this user to groups because of user\'s privacy settings.',
  'InviteToChannelError': 'Sorry, you can\'t add this user to channels because of user\'s privacy settings.',
  'AddMembersAlertTitle': 'Add %1$s',
  'AddOneMemberAlertTitle': 'Add member',
  'AddMembersAlertNamesText': 'Are you sure you want to add %1$s to **%2$s**?',
  'AddMembersAlertCountText': 'Are you sure you want to add %1$s to **%2$s**?',
  'AddMembersForwardMessages': 'Show the last 100 messages to the new members',
  'AddOneMemberForwardMessages': 'Show the last 100 messages to **%1$s**',
  'PinToTopLimitReached2': 'Sorry, you can only pin %1$s to the top in the main list. More chats can be pinned in Chat Folders and your Archive.',
  'FiltersSetupPinAlert': 'Set Up Folders',
  'AppName': 'Telegram',
  'OK': 'OK',
  'PinFolderLimitReached': 'Sorry, you can\'t pin any more chats to the top.',
  'Send': 'Send',
  'ChannelJoin': 'JOIN',
  'Yesterday': 'yesterday',
  'LeaveAComment': 'Leave a comment',
  'ViewInChat': 'View in chat',
  'LinkNotFound': 'Unfortunately, you can\'t access this message. You are not a member of the chat where it was posted.',
  'Create': 'Create',
  'ViewDiscussion': 'View discussion',
  'MessageScheduledUntilOnline': 'Scheduled until online',
  'ReportChat': 'Report',
  'ReportChatSpam': 'Spam',
  // "ReportChatFakeAccount": "Fake Account",
  'ReportChatViolence': 'Violence',
  'ReportChatPornography': 'Pornography',
  'ReportChatChild': 'Child Abuse',
  'ReportChatOther': 'Other',
  'ReportChatDescription': 'Description',
  'ReportInfo': 'Please enter any additional details relevant to your report.',
  'ReportSentInfo': 'Telegram moderators will review your report.\nThank you for your cooperation!',
  'ReportHint': 'Additional details...',
  'ChatHistory': 'Chat history for new members',
  'ShareContact': 'Share contact',
  'SendMessageTitle': 'Send message',
  'SendContactToGroupText': 'Do you want to send this contact to **%1$s**?',
  'ChannelBroadcast': 'Broadcast',
  'ChannelSilentBroadcast': 'Silent Broadcast',
  'Comment': 'Comment',
  'SendAnonymously': 'Send anonymously',
  'DiscardVoiceMessageTitle': 'Discard Voice Message',
  'DiscardVoiceMessageDescription': 'Are you sure you want to stop recording and discard your voice message?',
  'DiscardVoiceMessageAction': 'Discard',
  'AddContact': 'Add to contacts',
  'BlockUser': 'Block user',
  'MobileHidden': 'Mobile hidden',
  'MobileHiddenExceptionInfo': 'Phone number will be visible once %1$s adds you as a contact.',
  'FirstName': 'First name (required)',
  'LastName': 'Last name (optional)',
  'AreYouSureBlockContact2': 'Are you sure you want to block **%1$s**?',
  'UserBlocked': 'User blocked',
  'UserUnblocked': 'User unblocked',
  'AudioUnknownArtist': 'Unknown artist',
  'AudioUnknownTitle': 'Unknown title',
  'LogOut': 'Log out',
  'OnlineCount': {
    'one_value': '%1$d online',
    'other_value': '%1$d online'
  },
  'EditedMessage': 'edited',
  'GlobalSearch': 'Global search',
  'SearchMessages': 'Messages',
  'SearchAllChatsShort': 'Chats',
  'ClearButton': 'Clear',
  'FilterAllChats': 'All Chats',
  'FilterAllChatsShort': 'All',
  'Call': 'Call',
  'VideoCall': 'Video Call',
  'CallMessageOutgoing': 'Outgoing Call',
  'CallMessageIncoming': 'Incoming Call',
  'CallMessageVideoOutgoing': 'Outgoing Video Call',
  'CallMessageVideoIncoming': 'Incoming Video Call',
  'VoipExchangingKeys': 'Exchanging encryption keys',
  'VoipUnmute': 'Unmute',
  'SavingContentTitle': 'Content protection',
  'RestrictSavingContent': 'Restrict saving content',
  'RestrictSavingContentInfoGroup': 'Members won\'t be able to copy, save or forward content from this group.',
  'RestrictSavingContentInfoChannel': 'Subscribers won\'t be able to copy, save or forward content from this channel.',
  'ClearOtherSessionsHelp': 'Logs out all devices except for this one.',
  'SessionsListInfo': 'The official Telegram app is available for Android, iPhone, iPad, Windows, macOS and Linux.',
  'SponsoredMessage': 'sponsored',
  'OpenChannelPost': 'VIEW POST',
  'FilterNameHint': 'Folder name',
  'BotStart': 'START',
  'BotUnblock': 'RESTART',
  'BotStop': 'Block bot',
  'BotRestart': 'Restart bot',
  'ShareYouPhoneNumberTitle': 'Share your phone number?',
  'AreYouSureShareMyContactInfoBot': 'The bot will know your phone number. This can be useful for integration with other services.',
  'DistanceUnitsTitle': 'Distance units',
  'DistanceUnitsKilometers': 'Kilometers',
  'DistanceUnitsMiles': 'Miles',
  'PeopleNearby': 'People Nearby',
  'MakeMyselfVisible': 'Make Myself Visible',
  'MakeMyselfVisibleTitle': 'Show Your Profile?',
  'MakeMyselfVisibleInfo': 'Users nearby will be able to view your profile and send you messages. This may help you find new friends, but could also attract excessive attention. You can stop sharing your profile at any time.\n\nYour phone number will remain hidden.',
  'StopShowingMe': 'Stop Showing Me',
  'PeopleNearbyInfo2': 'Exchange contact info with people nearby and find new friends.',
  'NearbyCreateGroup': 'Create a Local group',
  'AwayTo': '%1$s away',
  'MessagePreview': 'Message Preview',
  'KMetersAway2': '%1$s km away',
  'MetersAway2': '%1$s m away',
  'MilesAway': '%1$s mi away',
  'FootsAway': '%1$s ft away',
  'PeopleNearbyHeader': 'People nearby',
  'ChatsNearbyHeader': 'Groups nearby',
  'ChatLocation': 'Location',
  'RequestToJoinGroupDescription': 'This group accepts new members only after they are approved by its admins.',
  'RequestToJoinChannelDescription': 'This channel accepts new subscribers only after they are approved by its admins.',
  'RequestToJoinSent': 'Join request sent',
  'RequestToJoinGroupApproved': 'Your request to join the group was approved',
  'RequestToJoinChannelApproved': 'Your request to join the channel was approved',
  'Update': 'UPDATE',
  'Reactions': 'Reactions',
  'DoubleTapSetting': 'Quick Reaction',
  'EnableReactions': 'Enable Reactions',
  'EnableReactionsChannelInfo': 'Allow subscribers to react to channel posts.',
  'EnableReactionsGroupInfo': 'Allow members to react to group messages.',
  'AvailableReactions': 'Available reactions',
  'NobodyViewed': 'Nobody viewed',
  'MessageSeen': {
    'one_value': 'Seen',
    'other_value': '%1$d Seen'
  },
  // "Close": "Close",
  'DataSettings': 'Data and Storage',
  'GroupsAndChannelsHelp': 'Change who can add you to groups and channels.',
  'SessionsInfo': 'Manage your sessions on all your devices.',
  'StickersBotInfo': 'Artists are welcome to add their own sticker sets using our @stickers bot.',
  'AutomaticMediaDownload': 'Automatic media download',
  'AutoDownloadPhotos': 'Photos',
  'AutoDownloadVideos': 'Videos',
  'AutoDownloadFiles': 'Files',
  'AutoDownloadOnAllChats': 'On in all chats',
  'AutoDownloadUpToOnAllChats': 'Up to %1$s in all chats',
  'AutoDownloadOff': 'Off',
  'AutoDownloadOnUpToFor': 'Up to %1$s for %2$s',
  'AutoDownloadOnFor': 'On for %1$s',
  'AutoDownloadContacts': 'Contacts',
  'AutoDownloadPm': 'PM',
  'AutoDownloadGroups': 'Groups',
  'AutoDownloadChannels': 'Channels',
  'AutoDownloadAudioInfo': 'Voice messages are tiny, so they\'re always downloaded automatically.',
  'AutoplayMedia': 'Auto-play media',
  'AutoDownloadPhotosTitle': 'Auto-download photos',
  'AutoDownloadVideosTitle': 'Auto-download videos and GIFs',
  'AutoDownloadFilesTitle': 'Auto-download files and music',
  'AutoDownloadMaxFileSize': 'Maximum file size',
  'AutodownloadSizeLimitUpTo': 'up to %1$s',
  'ResetAutomaticMediaDownload': 'Reset Auto-Download Settings',
  'ResetAutomaticMediaDownloadAlertTitle': 'Reset settings',
  'ResetAutomaticMediaDownloadAlert': 'Are you sure you want to reset auto-download settings?',
  'Reset': 'Reset',
  'SendMessageAsTitle': 'Send message as...',
  'Devices': 'Devices',
  'LanguageName': 'English',
  'EditCantEditPermissionsPublic': 'This permission is not available in public groups.',
  'VoipUserMicrophoneIsOff': '%s\'s microphone is off',
  'VoipUserCameraIsOff': '%s\'s camera is off',
  'PrivacyPhoneInfo4': 'This public link opens a chat with you:',
  'ReportChatIllegalDrugs': 'Illegal Drugs',
  'ReportChatPersonalDetails': 'Personal Details',
  'VoipPeerIncompatible': '**%1$s**\'s app is using an incompatible protocol. They need to update their app before you can call them.',
  'TelegramFeaturesUrl': 'https://t.me/TelegramTips',
  'ScamMessage': 'SCAM',
  'FakeMessage': 'FAKE',
  'TextCopied': 'Text copied to clipboard',
  'PaymentInvoice': 'INVOICE',
  'PaymentTestInvoice': 'TEST INVOICE',
  'PaymentReceipt': 'Receipt',
  'PaymentCheckout': 'Checkout',
  'PaymentTransactionTotal': 'Total',
  'PaymentTip': 'Tip',
  'PaymentTipOptional': 'Tip (Optional)',
  'PaymentCheckoutPay': 'PAY %1$s',
  'PaymentCheckoutMethod': 'Payment method',
  'PaymentCheckoutProvider': 'Payment provider',
  'PaymentCardNumber': 'Card Number',
  'PaymentCardSavePaymentInformation': 'Save Payment Information',
  'PaymentCardInfo': 'Payment info',
  'PaymentCardSavePaymentInformationInfoLine1': 'You can save your payment info for future use. It will be stored directly with the payment provider. Telegram has no access to your credit card data.',
  'Done': 'Done',
  'PaymentShippingMethod': 'Shipping methods',
  'PaymentNoShippingMethod': 'Sorry, it is not possible to deliver to your address.',
  'PaymentShippingInfo': 'Shipping Information',
  'PaymentShippingAddress': 'Shipping address',
  'PaymentShippingAddress1Placeholder': 'Address 1 (Street)',
  'PaymentShippingAddress2Placeholder': 'Address 2 (Street)',
  'PaymentShippingCityPlaceholder': 'City',
  'PaymentShippingStatePlaceholder': 'State',
  'PaymentShippingCountry': 'Country',
  'PaymentShippingZipPlaceholder': 'Postcode',
  'PaymentShippingReceiver': 'Receiver',
  'PaymentShippingName': 'Full Name',
  'PaymentShippingEmailPlaceholder': 'Email',
  'PaymentCheckoutPhoneNumber': 'Phone number',
  'PaymentCheckoutShippingMethod': 'Shipping method',
  'PaymentShippingSave': 'Save Shipping Information',
  'PaymentShippingSaveInfo': 'You can save your shipping info for future use.',
  'PaymentInfoHint': 'You paid **%1$s** for **%2$s**.',
  'PrivacyPayments': 'Payments',
  'PrivacyPaymentsClearInfo': 'You can delete your shipping info and instruct all payment providers to remove your saved credit cards. Note that Telegram never stores your credit card data.',
  'PrivacyPaymentsClear': 'Clear Payment and Shipping Info',
  'PrivacyPaymentsClearAlertTitle': 'Clear payment info',
  'PrivacyPaymentsClearAlertText': 'Are you sure you want to clear your payment and shipping info?',
  'PrivacyPaymentsPaymentInfoCleared': 'Payment info cleared.',
  'PrivacyPaymentsShippingInfoCleared': 'Shipping info cleared.',
  'PrivacyPaymentsPaymentShippingCleared': 'Payment and shipping info cleared.',
  'PrivacyClearShipping': 'Shipping info',
  'PrivacyClearPayment': 'Payment info',
  'Clear': 'Clear',
  'Save': 'Save',
  'PaymentCheckoutName': 'Name',
  'ClearRecentStickersAlertTitle': 'Clear recent stickers',
  'ClearRecentStickersAlertMessage': 'Do you want to clear all your recent stickers?',
  'PremiumStickersShort': 'Premium',
  'FavoriteStickers': 'Favorites',
  'AddToFavorites': 'Add to Favorites',
  'AddedToFavorites': 'Sticker added to Favorites.',
  'RemovedFromFavorites': 'Sticker was removed from Favorites.',
  'RemovedFromRecent': 'Sticker was removed from Recents.',
  'DeleteFromFavorites': 'Delete from Favorites',
  'DeleteFromRecent': 'Remove from Recent',
  'NewChatsFromNonContacts': 'New chats from unknown users',
  'ArchiveAndMute': 'Archive and Mute',
  'ArchiveAndMuteInfo': 'Automatically archive and mute new chats, groups and channels from non-contacts.',
  'PrivacyVoiceMessages': 'Voice Messages',
  'PrivacyVoiceMessagesTitle': 'Who can send me voice or video messages?',
  'PrivacyVoiceMessagesInfo': 'You can restrict who can send you voice or video messages with granular precision.',
  'PrivacyVoiceMessagesPremiumOnly': 'Only subscribers of *Telegram Premium* can restrict receiving voice messages.',
  'EmojiCount': {
    'other_value': '%1$d emoji'
  },
  'AddEmojiNotFound': 'Emoji pack not found.',
  'MessageContainsEmojiPack': 'This message contains emoji from %s pack.',
  'MessageContainsEmojiPacks': {
    'other_value': 'This message contains emoji from **%d Packs**.'
  },
  'EmojiPackCount': {
    'one_value': '%1$d Emoji Pack',
    'other_value': '%1$d Emoji Packs'
  },
  'ReactionsAll': 'All',
  'EnableSomeReactionsInfo': 'Members of the group can use only certain approved emoji as reactions to messages.',
  'EnableAllReactionsInfo': 'Members of the group can use any emoji as reactions to messages.',
  'DisableReactionsInfo': 'Members of the group can’t add any reactions to messages.',
  'OnlyAllowThisReactions': 'Only allow these reactions',
  'AllReactions': 'All reactions',
  'SomeReactions': 'Some reactions',
  'NoReactions': 'No reactions',
  'LimitReached': 'Limit Reached',
  'LimitReachedPinDialogs': 'You can\'t pin more than %1$d chats to the top. Unpin some that are currently pinned – or subscribe to **Telegram Premium** to double the limit to **%2$d** chats.',
  'LimitReachedPinDialogsPremium': 'Sorry, you can\'t pin more than %1$d chats to the top. Unpin some that are currently pinned.',
  'LimitReachedPinDialogsLocked': 'Sorry, you can\'t pin more than %1$d chats to the top. Unpin some that are currently pinned. We are working to let you increase this limit in the future.',
  'IncreaseLimit': 'Increase Limit',
  'LimitFree': 'Free',
  'LimitPremium': 'Premium',
  'ActionTTLChanged': 'un1 set messages to auto-delete in %1$s',
  'ActionTTLYouChanged': 'You set messages to auto-delete in %1$s',
  'ActionTTLChannelChanged': 'Messages in this channel will be automatically deleted after %1$s',
  'ActionTTLChannelDisabled': 'Messages in this channel will no longer be automatically deleted',
  'ActionTTLDisabled': 'un1 disabled the auto-delete timer',
  'ActionTTLYouDisabled': 'You disabled the auto-delete timer',
  'UsernamesProfileHeader': 'Username order',
  'UsernamesProfileHelp': 'Drag and drop links to change the order in which they will be displayed on your info page.',
  'UsernamesChannelHelp': 'Drag and drop links to change the order in which they will be displayed on the channel info page.',
  'UsernameLinkEditable': 'click to edit',
  'UsernameLinkActive': 'active',
  'UsernameLinkInactive': 'inactive',
  'UsernameActivateLink': 'Activate link',
  'UsernameDeactivateLink': 'Deactivate link',
  'UsernameActivateLinkProfileMessage': 'Do you want to show this link on your info page?',
  'UsernameDeactivateLinkProfileMessage': 'Do you want to hide this link from your info page?',
  'UsernameActivateLinkChannelMessage': 'Do you want to show this link on the channel info page?',
  'UsernameDeactivateLinkChannelMessage': 'Do you want to hide this link from the channel info page?',
  'Hide': 'Hide',
  'Show': 'Show',
  'UsernameActivateErrorTitle': 'Too many active links',
  'UsernameActivateErrorMessage': 'Sorry, you have too many active public links already. Please hide one of your active public links first.',
  'ChannelSignMessages': 'Sign Messages',
  'ChannelSignMessagesInfo': 'Add names of admins to the messages they post',
  'TopicWasCreatedAction': '%s was created',
  'Topics': 'Topics',
  'ForumToggleDescription': 'The group chat will be divided into topics created by admins or users.',
  'AnonymousNumber': 'Anonymous Number',
  'Info': 'Info',
  'BotSettings': 'Settings',
  'OpenMessage': 'VIEW MESSAGE',
  'OpenGroup': 'VIEW GROUP',
  'CloseTopic': 'Close topic',
  'RestartTopic': 'Reopen topic',
  'LimitReachedPinnedTopics': 'Sorry, you can\'t pin more than %d topics to the top.',
  'TopicProfileStatus': 'In %s',
  'AccDescrTopic': 'Topic',
  'DeleteTopics': {
    'one_value': 'Delete topic',
    'other_value': 'Delete topics'
  },
  'DeleteSelectedTopic': 'Are you sure you want delete %s?',
  'NewTopic': 'New Topic',
  'CreateTopicTitle': 'Choose a topic name and icon',
  'CreateGeneralTopicTitle': 'Choose topic name',
  'EditTopicHide': 'Show in Topics',
  'EditTopicHideInfo': 'If the \'General\' topic is hidden, group members can pull down in the topic list to view it.',
  'OpenUrlOption1': 'Log in to %1$s as **%2$s**',
  'OpenUrlOption2': 'Allow **%1$s** to send me messages',
  'OtherWebSessions': 'Connected websites',
  'WebSessionsTitle': 'Logged In with Telegram',
  'TerminateWebSessionText': 'Are you sure you want to disconnect %1$s?',
  'Disconnect': 'Disconnect',
  'TerminateAllWebSessions': 'Disconnect All Websites',
  'AreYouSureWebSessions': 'Are you sure you want to disconnect all websites where you logged in with Telegram?',
  'ClearOtherWebSessionsHelp': 'You can log in on websites that support signing in with Telegram.',
  'TerminateWebSessionInfo': 'Click to disconnect from your Telegram account.',
  'EnablePhotoSpoiler': 'Hide with spoiler',
  'DisablePhotoSpoiler': 'Remove spoiler',
  'LimitReachedFolders': 'You have reached the limit of **%1$d** folders. You can double the limit to **%2$d** folders by subscribing to **Telegram Premium**.',
  'LimitReachedFoldersPremium': 'You have reached the limit of **%1$d** folders for this account.',
  'LimitReachedFoldersLocked': 'You have reached the limit of **%1$d** folders for this account. We are working to let you increase this limit in the future.',
  'LimitReachedSharedFolderInvites': 'You have reached the limit of **%1$d** links. You can double the limit to **%2$d** links by subscribing to **Telegram Premium**.',
  'LimitReachedSharedFolderInvitesPremium': 'You have reached the limit of **%1$d** links.',
  'LimitReachedSharedFolderInvitesLocked': 'You have reached the limit of **%1$d** links. We are working to let you increase this limit in the future.',
  'FwdMessageToSavedMessages': 'Message forwarded to **Saved Messages**.',
  'FwdMessagesToSavedMessages': 'Messages forwarded to **Saved Messages**.',
  'ColorTheme': 'Color theme',
  'SendAsFile': 'Send as file',
  'SendAsFiles': 'Send as files',
  'ChatThemeChangedYou': 'You changed the chat theme to %1$s',
  'ChatThemeChangedTo': '%1$s changed the chat theme to %2$s',
  'ChatThemeDisabled': '%1$s disabled the chat theme',
  'ChatThemeDisabledYou': 'You disabled the chat theme',
  'ThemeDay': 'Day',
  'ThemeNight': 'Night',
  'AutoNightSystemDefault': 'System Default',
  'GlobalAttachPlainRestricted': 'Sending text messages isn\'t allowed in this group.',
  'GlobalAttachDocumentsRestricted': 'Sending documents isn\'t allowed in this group.',
  'GlobalAttachMediaRestricted': 'Sending media isn\'t allowed in this group.',
  'GlobalAttachAudioRestricted': 'Sending music isn\'t allowed in this group.',
  'GlobalAttachPhotoRestricted': 'Sending photos isn\'t allowed in this group.',
  'GlobalAttachVideoRestricted': 'Sending videos isn\'t allowed in this group.',
  'GlobalAttachVoiceRestricted': 'Sending voice isn\'t allowed in this group.',
  'GlobalAttachRoundRestricted': 'Sending round videos isn\'t allowed in this group.',
  'GlobalAttachInlineRestricted': 'Sending inline content isn\'t allowed in this group.',
  'GlobalAttachStickersRestricted': 'Stickers aren\'t allowed in this group.',
  'GlobalAttachGifRestricted': 'Sending GIFs is not allowed in this group.',
  'GlobalAttachEmojiRestricted': 'Text messages aren\'t allowed in this group.',
  'GlobalSendMessageRestricted': 'Sending messages is not allowed in this group.',
  'ErrorSendRestrictedPollsAll': 'Sorry, sending polls is not allowed in this group.',
  'Remove': 'Remove',
  'ChannelBlockUser': 'Remove User',
  'StickersName': 'Stickers and Emoji',
  'LoopAnimatedStickersInfo': 'Animated stickers will play continuously in chats.',
  'SuggestStickersAll': 'All Sets',
  'SuggestStickersInstalled': 'My Sets',
  'SuggestStickersNone': 'None',
  'DynamicPackOrder': 'Dynamic Pack Order',
  'DynamicPackOrderInfo': 'Automatically place recently used sticker packs at the front of the panel.',
  'GiftPremium': 'Gift Premium',
  'GiftTelegramPremiumTitle': 'Gift Telegram Premium',
  'GiftTelegramPremiumDescription': 'Give **%1$s** access to exclusive features with **Telegram Premium**.',
  'PricePerMonth': '%1$s / month',
  'GiftSubscriptionFor': 'Gift Subscription for %1$s',
  'ActionGiftInbound': 'un1 sent you a gift for **un2**',
  'ActionGiftOutbound': 'You have sent a gift for **un2**',
  'ActionGiftPremiumTitle': 'Telegram Premium',
  'ActionGiftPremiumSubtitle': 'for %1$s',
  'ChatAdmin': 'admin',
  'BotRequestAttachPermission': '**%1$s** requests to be added as an option to your attachment menu so you can access it from any chat.',
  'BotCantAddToAttachMenu': 'This bot can\'t be added to the attachment menu.',
  'BotAlreadyAddedToAttachMenu': 'This bot is already added to your attachment menu.',
  'AddBot': 'Add Bot',
  'ActionAttachMenuBotAllowed': 'You allowed this bot to message you when you added it to your attachment menu.',
  'SendMessage': 'Send Message',
  'Mention': 'Mention',
  'OpenChannel2': 'Open Channel',
  'OpenGroup2': 'Open Group',
  'BotWebViewOpenBot': 'Open Bot',
  'BotWebViewReloadPage': 'Reload Page',
  'BotWebViewDeleteBot': 'Remove from Menu',
  'SelectChat': 'Select Chat',
  'BotOpenPageTitle': 'Open page',
  'BotOpenPageMessage': '**%1$s** would like to open its web app to proceed.\n\nIt will be able to access your **IP address** and basic device info.',
  'BotWebViewChangesMayNotBeSaved': 'Changes that you made may not be saved.',
  'BotWebViewCloseAnyway': 'Close anyway',
  'CancelPollAlertTitle': 'Discard poll?',
  'CancelPollAlertText': 'Are you sure you want to discard this poll?',
  'Discard': 'Discard',
  'Close': 'Close',
  'ActionBotWebViewData': 'Data from the "%1$s" button was transferred to the bot.',
  'LocationUpdatedJustNow': 'updated just now',
  'UpdatedMinutes': {
    'one_value': 'updated %1$d minute ago',
    'other_value': 'updated %1$d minutes ago'
  },
  'InviteLink': 'Invite Link',
  'InviteLinks': 'Invite Links',
  'FilterEdit': 'Edit folder',
  'FilterEditAll': 'Edit folders',
  'FilterIncludeInfo': 'Choose chats or types of chats that will appear in this folder.',
  'FilterExcludeInfo': 'Choose chats or types of chats that will not appear in this folder.',
  'FilterRemoveChats': 'Remove Chats',
  'DeleteLink': 'Delete Link',
  'ShareLink': 'Share Link',
  'HideAboveTheList': 'Hide from Chat List',
  'SearchEmptyViewTitle': 'No Results',
  'ChannelCreator': 'Owner',
  'EditAdminPromotedBy': 'Promoted by %1$s',
  'EditAdmin': 'Admin Rights',
  'EditAdminWhatCanDo': 'What can this admin do?',
  'EditAdminChangeChannelInfo': 'Change Channel Info',
  'EditAdminChangeGroupInfo': 'Change Group Info',
  'EditAdminPostMessages': 'Post Messages',
  'EditAdminEditMessages': 'Edit Messages of Others',
  'EditAdminDeleteMessages': 'Delete Messages of Others',
  'EditAdminGroupDeleteMessages': 'Delete Messages',
  'EditAdminAddAdmins': 'Add New Admins',
  'EditAdminSendAnonymously': 'Remain Anonymous',
  'StartVoipChatPermission': 'Manage Live Streams',
  'EditAdminBanUsers': 'Ban Users',
  'EditAdminAddUsersViaLink': 'Invite Users via Link',
  'EditAdminPinMessages': 'Pin Messages',
  'EditAdminCantEdit': 'You can\'t edit the rights of this admin.',
  'EditCantEditPermissions': 'You cannot change this permission.',
  'EditAdminRank': 'Custom title',
  'EditAdminRankInfo': 'A title that members will see instead of \'%1$s\'.',
  'DeleteBanUser': 'Ban user',
  'DeleteReportSpam': 'Report spam',
  'DeleteAllFrom': 'Delete all from %1$s',
  'ChannelAddSubscribers': 'Add Subscribers',
  'ChannelHideMembers': 'Hide Members',
  'ChannelHideMembersInfo': 'Switch on to hide the list of members in this group. Admins will remain visible.',
  'ChannelBlacklist': 'Removed Users',
  'NoBlockedGroup2': 'Users removed from the group by admins can\'t rejoin via invite links.',
  'NoBlockedChannel2': 'Users removed from the channel by admins can\'t rejoin via invite links.',
  'UserRemovedBy': 'Removed by %1$s',
  'AddBannedErrorAdmin': 'You can\'t ban this user because they are an admin in this group and you are not allowed to demote them.',
  'AddToGroup': 'Add to Group',
  'AddToChannel': 'Add to Channel',
  'SetAsAdmin': 'Promote to admin',
  'EditAdminRights': 'Edit admin rights',
  'KickFromSupergroup': 'Restrict user',
  'KickFromGroup': 'Remove from group',
  'DiscussionInfo': 'Add a group chat for comments',
  'LinkedChannel': 'Linked Channel',
  'DiscussionChannelHelp3': 'Select a group chat that will host comments from your channel.',
  'DiscussionChannelHelp2': 'Everything you post in the channel will be forwarded to this group.',
  'ChannelTopicsDiscussionForbidden': 'Topics are not yet available in the discussion groups of channels.',
  'DiscussionLinkGroup': 'Link Group',
  'DiscussionChannelGroupSetHelp2': '**%1$s** is selected as the group that hosts comments for your channel.',
  'DiscussionUnlinkGroup': 'Unlink Group',
  'DiscussionUnlinkGroupAlert': 'Are you sure you want to unlink **%1$s** from this group?',
  'DiscussionUnlinkChannelAlert': 'Are you sure you want to unlink **%1$s** from this channel?',
  'DiscussionUnlink': 'Unlink',
  'DiscussionGroupHelp': 'This group is linked as the discussion board for %1$s.',
  'DiscussionGroupHelp2': 'All new posts from this channel are forwarded to the group.',
  'DiscussionUnlinkChannel': 'Unlink Channel',
  'DiscussionLinkGroupAlertHistory': '"Chat history for new members" will be switched to Visible.',
  'DiscussionCreateGroup': 'Create a New Group',
  'UserRestrictionsBy': 'Restricted by %1$s',
  'ChannelAntiSpam': 'Aggressive Anti-Spam',
  'ChannelAntiSpamInfo': 'Telegram will filter more spam, but may occasionally affect ordinary messages. You can report False Positives in Recent Actions.',
  'ChannelLinkInfo': 'Anyone who has Telegram installed will be able to join your channel by following this link.',
  'CreateNewLink': 'Create a New Link',
  'DeleteAllRevokedLinks': 'Delete All Revoked Links',
  'RevokedLinks': 'Revoked Links',
  'CanJoin': {
    'other_value': '%1$d can join'
  },
  'PeopleJoined': {
    'one_value': '%1$d person joined',
    'other_value': '%1$d people joined'
  },
  'PeopleJoinedRemaining': {
    'other_value': '%1$d remaining'
  },
  'NewLink': 'New Link',
  'LinkNameHint': 'Link Name (Optional)',
  'LinkNameHelp': 'Only admins will see this name.',
  'ApproveNewMembers': 'Request Admin Approval',
  'ApproveNewMembersDescription': 'Turn this on if you want users to join only after they are approved by an admin.',
  'LimitByPeriod': 'Limit by time period',
  'LimitNumberOfUses': 'Limit by number of users',
  'TimeLimitHelp': 'You can make the link expire after a certain time.',
  'UsesLimitHelp': 'You can make the link work only for a certain number of users.',
  'LinkIsExpired': 'The time limit for this link has expired.',
  'LinkIsExpiredLimitReached': 'This link reached its usage limit.',
  'LinkCreatedeBy': 'Link created by',
  'PeopleCanJoinViaLinkCount': {
    'one_value': '%s person can join via this link.',
    'other_value': '%s people can join via this link.'
  },
  'MemberRequests': 'Join Requests',
  'SubscribeRequests': 'Join Requests',
  'JoinRequests': {
    'one_value': '%1$d join request',
    'other_value': '%1$d join requests'
  },
  'Dismiss': 'Dismiss',
  'RequestedToJoinAt': 'requested to join %1$s',
  'LinksCreatedByOtherAdmins': 'Links created by other admins',
  'InviteLinkCount': {
    'one_value': '%1$d invite link',
    'other_value': '%1$d invite links'
  },
  'LinksCreatedByThisAdmin': 'Invite links created by this admin',
  'DeleteThisChat': 'Delete this chat',
  'ShareFile': 'Share',
  'StoryPinnedToProfile': 'Story posted to your profile.',
  'StoryArchivedFromProfile': 'This story is hidden from your profile.',
  'StorySavedTitle': {
    'one_value': '%d story saved to your profile',
    'other_value': '%d stories saved to your profile'
  },
  'StoryArchived': {
    'one_value': '%d story removed from your profile',
    'other_value': '%d stories removed from your profile'
  },
  'DeleteStoryTitle': 'Delete Story',
  'DeleteStoriesTitle': 'Delete Stories',
  'DeleteStorySubtitle': 'Are you sure you want to delete this story?',
  'DeleteStoriesSubtitle': {
    'one_value': 'Are you sure you want to delete %d story?',
    'other_value': 'Are you sure you want to delete %d stories?'
  },
  'ProfileStoriesArchiveHint': 'Only you can see archived stories unless you choose to post them to your profile.',
  'StoryCloseFriendsHint': 'You are seeing this story because **%s** added you to their list of Close Friends.',
  'StorySelectedContactsHint': 'Only some users **%s** selected can view this story.',
  'StoryContactsHint': 'Only **%s’s** contacts can view this story.',
  'Views': {
    'one_value': '%1$s view',
    'other_value': '%1$s views'
  },
  'NobodyViews': 'No views yet',
  'NobodyViewsArchived': 'No views available',
  'NotificationsStoryMute2': 'Do Not Notify\nAbout Stories',
  'NotificationsStoryUnmute2': 'Notify About\nStories',
  'ArchivePeerStories': 'Hide Stories',
  'UnarchiveStories': 'Unhide Stories',
  'SavedStories': 'Posted Stories',
  'ArchivedStories': 'Archived Stories',
  'StoryViewLocation': 'View Location',
  'BotWebAppDisclaimerSubtitle': 'You are about to use a mini app operated by an independent party **not affiliated with Telegram**. You must agree to the Terms of Use for mini apps to continue.',
  'TermsOfUse': 'Terms of Use',
  'WebAppDisclaimerUrl': 'https://telegram.org/tos/mini-apps',
  'BotWebViewStartPermission': 'To launch this web app, you will connect to its website.',
  'BotWebAppInstantViewOpen': 'Launch',
  'BotAttachMenuShortcatAddedAttachAndSide': '**%s** shortcuts added in attachment menu and side menu.',
  'BotAttachMenuShortcatAddedSide': '**%s** shortcut added in side menu.',
  'BotAttachMenuShortcatAddedAttach': '**%s** shortcut added in attachment menu.',
  'NotificationsStoryMutedHint': 'Disabled notifications for **%s** stories.',
  'NotificationsStoryUnmutedHint': 'You will receive a notification whenever **%s** posts a new story.',
  'StoriesMovedToContacts': 'Stories of **%s** were moved to the **Archive**.',
  'StoriesMovedToDialogs': 'Stories of **%s** were moved to **Chats**.',
  'StorySharedTo': 'Story forwarded to **%s**.',
  'StorySharedToSavedMessages': 'Story forwarded to **Saved Messages**',

  // * macos
  'AccountSettings.Filters': 'Chat Folders',
  'AccountSettings.Notifications': 'Notifications and Sounds',
  'AccountSettings.PrivacyAndSecurity': 'Privacy and Security',
  'AccountSettings.Language': 'Language',
  'Alert.UserDoesntExists': 'Sorry, this user doesn\'t seem to exist.',
  'Alert.Confirm.Discard': 'Discard',
  'Appearance.Reset': 'Reset to Defaults',
  'AutoDownloadSettings.Delimeter': ', ',
  'AutoDownloadSettings.LastDelimeter': ' and ',
  'Bio.Description': 'Any details such as age, occupation or city.\nExample: 23 y.o. designer from San Francisco',
  'Call.Accept': 'Accept',
  'Call.Decline': 'Decline',
  'Call.End': 'End',
  'Call.Camera': 'Camera',
  'Call.Mute': 'Mute',
  'Call.Recall': 'Recall',
  'Call.Close': 'Close',
  'Call.Screen': 'Screen',
  'Call.Confirm.Discard.Voice.Header': 'Video Chat in Progress',
  'Call.Confirm.Discard.Voice.ToVoice.Text': 'Leave video chat in "%1$@" and start a new one in "%2$@"?',
  'Call.Confirm.Discard.Voice.ToCall.Text': 'Leave video chat in "%1$@" and start a call with "%2$@"?',
  'Call.Confirm.Discard.Call.Header': 'Call in Progress',
  'Call.Confirm.Discard.Call.ToVoice.Text': 'End call with "%1$@" and start a video chat in "%2$@"?',
  'Call.Confirm.Discard.Call.ToCall.Text': 'End call with "%1$@" and start a video chat in "%2$@"?',
  'Call.PrivacyErrorMessage': 'Sorry, you cannot call %@ because of their privacy settings.',
  'Call.StatusRequesting': 'Contacting...',
  'Call.StatusRinging': 'Ringing...',
  'Call.StatusConnecting': 'Connecting...',
  'Call.StatusEnded': 'Call Ended',
  'Call.StatusFailed': 'Call Failed',
  'Call.StatusBusy': 'Busy',
  'Call.StatusCalling': 'is calling you...',
  'Contacts.PhoneNumber.NotRegistred': 'The person with this phone number is not registered on Telegram yet.',
  'Channel.UsernameAboutChannel': 'People can share this link with others and can find your channel using Telegram search.',
  'Channel.UsernameAboutGroup': 'People can share this link with others and find your group using Telegram search.',
  'Chat.Accessory.Forward': {
    'one_value': 'Forward Message',
    'other_value': 'Forward %d Messages'
  },
  'Chat.Accessory.Forward.You': 'You',
  'Chat.Accessory.Forward.From': 'From',
  'Chat.Accessory.Hidden': {
    'one_value': 'Forward Message (sender\'s name hidden)',
    'other_value': 'Forward %d Messages (senders\' names hidden)'
  },
  'Chat.Alert.Forward.Action.Another': 'Forward to Another Chat',
  'Chat.Alert.Forward.Action.Hide1': {
    'one_value': 'Hide Sender\'s Name',
    'other_value': 'Hide Senders\' Names'
  },
  'Chat.Alert.Forward.Action.Show1': {
    'one_value': 'Show Sender\'s Name',
    'other_value': 'Show Senders\' Names'
  },
  'Chat.Alert.Forward.Action.ShowCaption': {
    'one_value': 'Show Caption',
    'other_value': 'Show Captions'
  },
  'Chat.Alert.Forward.Action.HideCaption': {
    'one_value': 'Hide Caption',
    'other_value': 'Hide Captions'
  },
  'Chat.CopySelectedText': 'Copy Selected Text',
  'Chat.Confirm.Unpin': 'Would you like to unpin this message?',
  'Chat.Context.Reacted': '%1$@/%2$@ Reacted',
  'Chat.Context.ReactedFast': {
    'other_value': '%d Reacted'
  },
  'Chat.Confirm.ReportSpam.Header': 'Report Spam',
  'Chat.Confirm.ReportSpam.Channel': 'Report Spam and Leave Channel?',
  'Chat.Confirm.ReportSpam.Group': 'Report Spam and Leave Group?',
  'Chat.ChannelBadge': 'channel',
  'Chat.Date.ScheduledFor': 'Scheduled for %@',
  'Chat.Date.ScheduledForToday': 'Scheduled for today',
  'Chat.DropTitle': 'Drop files here to send them',
  'Chat.DropQuickDesc': 'in a quick way',
  'Chat.DropAsFilesDesc': 'without compression',
  'Chat.Edit.Cancel.Text': 'Are you sure you want to discard all changes?',
  'Chat.File.QuickLook.Svg': 'Previewing this file can potentially expose your IP address to its creator.',
  'Chat.Input.ReplyToAnswer': 'Reply to message in topics',
  'Chat.OwnerBadge': 'owner',
  'Chat.SendVoice.PrivacyError': '%@ doesn\'t accept voice and video messages',
  'Chat.Service.Call.Cancelled': 'Canceled',
  'Chat.Service.Call.Missed': 'Missed',
  'Chat.Service.PeerJoinedTelegram': '%@ joined Telegram',
  'Chat.Service.Channel.UpdatedTitle': 'Channel renamed to "%@"',
  'Chat.Service.Channel.UpdatedPhoto': 'Channel photo updated',
  'Chat.Service.Channel.RemovedPhoto': 'Channel photo removed',
  'Chat.Service.Channel.UpdatedVideo': 'Channel photo updated',
  'Chat.Service.BotPermissionAllowed': 'You allowed this bot to message you when you logged in on %@',
  'Chat.Service.Group.UpdatedPinnedMessage': '%@ pinned "%@"',
  'Chat.Service.Group.TopicEdited.Icon': '%1$@ changed topic icon to %2$@',
  'Chat.Service.Group.TopicEdited.Icon.Removed': '%1$@ removed the icon',
  'Chat.Service.Group.TopicEdited.Title': '%1$@ changed topic name to "%2$@"',
  'Chat.Service.Group.TopicEdited.Paused': '%1$@ closed the topic',
  'Chat.Service.Group.TopicEdited.Resumed': '%1$@ reopened the topic',
  'Chat.Service.Group.TopicEdited.You.Icon': 'You changed topic icon to %1$@',
  'Chat.Service.Group.TopicEdited.You.Icon.Removed': 'You removed the icon',
  'Chat.Service.Group.TopicEdited.You.Title': 'You changed topic name to "%1$@"',
  'Chat.Service.Group.TopicEdited.You.Paused': 'You closed the topic',
  'Chat.Service.Group.TopicEdited.You.Resumed': 'You reopened the topic',
  'Chat.Service.Group.TopicEdited.You.Hided': 'You hid the general topic',
  'Chat.Service.Group.TopicEdited.You.Unhided': 'You unhid the general topic',
  'Chat.Service.Group.TopicEdited.Hided': '%1$@ hid the general topic',
  'Chat.Service.Group.TopicEdited.Unhided': '%1$@ unhid the general topic',
  'Chat.Service.PaymentSent1': 'You have successfully transferred **%1$@** to **%2$@** for **%3$@**',
  'Chat.Service.PaymentSent1NoTitle': 'You have successfully transferred **%1$@** to **%2$@**',
  'Chat.Service.PaymentSentRecurringInit': 'You successfully transferred **%1$@** to **%2$@** for **%3$@** and allowed future recurring payments',
  'Chat.Service.PaymentSentRecurringInitNoTitle': 'You successfully transferred **%1$@** to **%2$@** and allowed future recurring payments',
  'Chat.Service.PaymentSentRecurringUsed': 'You have just successfully transferred **%1$@** to **%2$@** for **%3$@** via recurrent payments',
  'Chat.Service.PaymentSentRecurringUsedNoTitle': 'You have just successfully transferred **%1$@** to **%2$@** via recurrent payments',
  'Chat.Service.PeerRequested': 'You shared %1$@ with %2$@.',
  'Chat.Service.VoiceChatStarted': '%1$@ started a [video chat](open)',
  'Chat.Service.VoiceChatStartedYou': 'You started a [video chat](open)',
  'Chat.Service.VoiceChatStarted.Channel': '[Live Stream](open) started',
  'Chat.Service.VoiceChatFinished': '%1$@ ended the video chat (%2$@)',
  'Chat.Service.VoiceChatFinishedYou': 'You ended the video chat (%@)',
  'Chat.Service.VoiceChatFinished.Channel': 'Live Stream ended (%1$@)',
  'Chat.Service.VoiceChatInvitation': '%1$@ invited %2$@ to the [video chat](open)',
  'Chat.Service.VoiceChatInvitationByYou': 'You invited %1$@ to the [video chat](open)',
  'Chat.Service.VoiceChatInvitationForYou': '%1$@ invited you to the [video chat](open)',
  'Chat.Service.PeerRequest.Confirm.Plain': 'Are you sure you want to send %1$@ to %2$@?',
  'Chat.Service.PeerRequest.Confirm.Permission': 'Are you sure you want to send %1$@ to %2$@? This will also add %3$@ to %4$@ with the following rights: %5$@',
  'Chat.Service.PeerRequest.Confirm.Ok': 'Send',
  'ChatService.UserJoinedGroupByRequest': '%@ was accepted to the group',
  'ChatService.UserJoinedChannelByRequest': '%@ joined the channel by request',
  'ChatList.Service.VoiceChatScheduled': '%1$@ scheduled a video chat for %2$@',
  'ChatList.Service.VoiceChatScheduledYou': 'You scheduled a video chat for %2$@',
  'Chat.Poll.Unvote': 'Retract Vote',
  'Chat.Poll.Stop': 'Stop Poll',
  'Chat.Poll.ViewResults': 'View Results',
  'Chat.Poll.SubmitVote': 'Vote',
  'Chat.Poll.Type.Anonymous': 'Anonymous Poll',
  'Chat.Poll.Type.Public': 'Poll',
  'Chat.Poll.Type.AnonymousQuiz': 'Anonymous Quiz',
  'Chat.Poll.Type.Quiz': 'Quiz',
  'Chat.Poll.Type.Closed': 'Final Results',
  'Chat.Poll.TotalVotes1': {
    'one_value': '%d vote',
    'other_value': '%d votes'
  },
  'Chat.Quiz.TotalVotes': {
    'one_value': '%d answer',
    'other_value': '%d answers'
  },
  'Chat.Poll.TotalVotesEmpty': 'No votes yet',
  'Chat.Poll.TotalVotesResultEmpty': 'No votes',
  'Chat.Quiz.TotalVotesEmpty': 'No answers yet',
  'Chat.Quiz.TotalVotesResultEmpty': 'No answers',
  // "Chat.Poll.Stop.Confirm.Header": "Stop Poll?",
  // "Chat.Poll.Stop.Confirm.Text": "If you stop this poll now, nobody will be able to vote in it anymore. This action cannot be undone.",
  // "Chat.Pinned.UnpinAll": {
  //   "one_value": "Unpin %d Message",
  //   "other_value": "Unpin All %d Messages"
  // },
  'Chat.Pinned.DontShow': 'Don\'t Show Pinned Messages',
  'Chat.Title.Comments': {
    'one_value': '%d Comment',
    'other_value': '%d Comments'
  },
  // 'Chat.TopicBadge': 'topic creator',
  'ChatTitle.ReportMessages': 'Report Messages',
  'Chat.Send.WithoutSound': 'Send Without Sound',
  'Chat.Send.SetReminder': 'Set a Reminder',
  'Chat.Send.ScheduledMessage': 'Schedule Message',
  'Chat.SendAs.PersonalAccount': 'personal account',
  'Chat.UnpinAllMessagesConfirmation': {
    'one_value': 'Do you want to unpin %d message in this chat?',
    'other_value': 'Do you want to unpin all %d messages in this chat?'
  },
  'Chat.Header.RequestToJoin': {
    'one_value': '%d Join Request',
    'other_value': '%d Join Requests'
  },
  'Chat.Message.Ad.Text': 'Unlike other apps, Telegram never uses your private data to target ads. Sponsored messages on Telegram are based solely on the topic of the public channels in which they are shown. This means that no user data is mined or analyzed to display ads, and every user viewing a channel on Telegram sees the same sponsored messages.\n\nUnlike other apps, Telegram doesn\'t track whether you tapped on a sponsored message and doesn\'t profile you based on your activity. We also prevent external links in sponsored messages to ensure that third parties can’t spy on our users. We believe that everyone has the right to privacy, and technological platforms should respect that.\n\nTelegram offers a free and unlimited service to hundreds of millions of users, which involves significant server and traffic costs. In order to remain independent and stay true to its values, Telegram developed a paid tool to promote messages with user privacy in mind. We welcome responsible advertisers at:\n\n%@\n\nSponsored Messages are currently in test mode. Once they are fully launched and allow Telegram to cover its basic costs, we will start sharing ad revenue with the owners of public channels in which sponsored messages are displayed.\n\nOnline ads should no longer be synonymous with abuse of user privacy. Let us redefine how a tech company should operate – together.',
  'Chat.Message.Ad.ReadMore': 'Read More',
  'Chat.Message.ViewChannel': 'VIEW CHANNEL',
  'Chat.Message.ViewBot': 'VIEW BOT',
  'Chat.Message.ViewGroup': 'VIEW GROUP',
  'Chat.Message.SendMessage': 'SEND MESSAGE',
  'Chat.Message.Sponsored.What': 'What are sponsored messages?',
  'Chat.Message.Sponsored.Link': 'https://promote.telegram.org',
  'Chat.Voice.Transribe.Error': 'No speech detected',
  'Chat.VoiceChat.JoinLink.Participants_ZeroValueHolder': 'no one joined yet',
  'Checkout.2FA.Text': 'Saving payment details is only available with 2-Step Verification.',
  'Checkout.NewCard.CardholderNamePlaceholder': 'Cardholder Name',
  'Checkout.PasswordEntry.Title': 'Payment Confirmation',
  'Checkout.PasswordEntry.Pay': 'Pay',
  'Checkout.PasswordEntry.Text': 'Your card %@ is on file. To pay with this card, please enter your 2-Step-Verification password.',
  'Checkout.PayPrice': 'Pay %@',
  'Checkout.WebConfirmation.Title': 'Complete Payment',
  'ChatList.Context.Mute': 'Mute',
  'ChatList.Context.Unmute': 'Unmute',
  'ChatList.Context.Pin': 'Pin',
  'ChatList.Context.Unpin': 'Unpin',
  'ChatList.Context.DeleteChat': 'Delete Chat',
  'ChatList.Context.DeleteAndExit': 'Delete and Leave',
  'ChatList.Context.LeaveChannel': 'Leave Channel',
  'ChatList.Context.LeaveGroup': 'Leave Group',
  'ChatList.Service.Call.incoming': 'Incoming Call (%@)',
  'ChatList.Service.Call.outgoing': 'Outgoing Call (%@)',
  'ChatList.Service.VideoCall.incoming': 'Incoming Video Call (%@)',
  'ChatList.Service.VideoCall.outgoing': 'Outgoing Video Call (%@)',
  'ChatList.Service.Call.Cancelled': 'Canceled Call',
  'ChatList.Service.Call.Missed': 'Missed Call',
  'ChatList.Service.VideoCall.Cancelled': 'Canceled Video Call',
  'ChatList.Service.VideoCall.Missed': 'Missed Video Call',
  'ChatList.Service.VoiceChatScheduled.Channel': 'Video chat scheduled for %@',
  'ChatList.Filter.Header': 'Create folders for different groups of chats and quickly switch between them.',
  'ChatList.Filter.NewTitle': 'Create Folder',
  'ChatList.Filter.List.Title': 'Chat Folders',
  'ChatList.Filter.Include.AddChat': 'Add Chats',
  // "ChatList.Filter.All": "All",
  'ChatList.Filter.Contacts': 'Contacts',
  'ChatList.Filter.NonContacts': 'Non-Contacts',
  'ChatList.Filter.Groups': 'Groups',
  'ChatList.Filter.Channels': 'Channels',
  'ChatList.Filter.Bots': 'Bots',
  'ChatList.Filter.MutedChats': 'Muted',
  'ChatList.Filter.ReadChats': 'Read',
  'ChatList.Filter.Archive': 'Archived',
  'ChatList.Filter.Include.LimitReached': 'Sorry, you can only add up to 100 individual chats. Try using chat types.',
  'ChatList.Filter.Exclude.LimitReached': 'Sorry, you can only add up to 100 individual chats. Try using chat types.',
  'ChatList.Filter.Confirm.Remove.Header': 'Remove Folder',
  'ChatList.Filter.Confirm.Remove.Text': 'Are you sure you want to remove this folder? Your chats will not be deleted.',
  'ChatList.Mute.1Hour': 'For 1 Hour',
  'ChatList.Mute.4Hours': 'For 4 Hours',
  'ChatList.Mute.8Hours': 'For 8 Hours',
  'ChatList.Mute.1Day': 'For 1 Day',
  'ChatList.Mute.3Days': 'For 3 Days',
  'ChatList.Mute.Forever': 'Forever',
  'Channel.EditAdmin.ManageCalls': 'Manage Video Chats',
  'Channel.EditAdmin.PermissionInviteSubscribers': 'Add Subscribers',
  'Channel.EditAdmin.ManageTopics': 'Manage Topics',
  'Channel.Admin.Dismiss': 'Dismiss Admin',
  'Channel.Admin.AdminAccess': 'This admin will be able to add new admins with equal or fewer rights.',
  'Channel.Admin.AdminRestricted': 'This admin will not be able to add new admins.',
  'Channel.DescriptionHolderDescrpiton': 'You can provide an optional description for your channel.',
  'Channel.Persmission.MessageBlock': 'Text is not Allowed',
  'ChannelVisibility.Confirm.MakePrivate.Channel': 'If you make this channel private, the name @%@ will be removed. Anyone else will be able to take it for their public groups or channels.',
  'ChannelVisibility.Confirm.MakePrivate.Group': 'If you make this group private, the name @%@ will be removed. Anyone else will be able to take it for their public groups or channels.',
  'Context.ViewStickerSet': 'View Sticker Set',
  'CreateGroup.NameHolder': 'Group Name',
  'CustomEmoji.PremiumAlert': 'Subscribe to Telegram Premium to unlock this emoji. [Read More]()',
  'Date.Today': 'Today',
  'DeleteChat.DeleteGroupForAll': 'Delete for all members',
  'DeleteChannelForAll': 'Delete for all subscribers',
  'Discussion.Set.Modal.Text.PublicChannelPublicGroup': 'Do you want to make **%@** the discussion board for **%@**?',
  'DiscussionController.Group.Title': 'Linked Channel',
  'DiscussionController.Channel.Title': 'Discussion Group',
  'DiscussionController.PrivateGroup': 'private group',
  'DiscussionController.PrivateChannel': 'private channel',
  'ForumTopic.Context.Info': 'Group Info',
  'ForumTopic.Context.AddMember': 'Add Members',
  'ForumTopic.Context.ShowAsMessages': 'View as Messages',
  'ForumTopic.Context.New': 'Create Topic',
  'ForumTopic.Name.Placeholder': 'Topic Name',
  'ForumTopic.Title.Edit': 'Edit Topic',
  'EditAccount.Username': 'Username',
  'EditAccount.Title': 'Edit Profile',
  'EditAccount.Logout': 'Log Out',
  'EditInvitation.ExpiryDate': 'Expiry Date',
  'EditInvitation.Never': 'Never',
  'EditInvitation.Unlimited': 'Unlimited',
  'EditInvitation.NumberOfUsers': 'Number of Users',
  'Emoji.Recent': 'Frequently Used',
  'Emoji.SmilesAndPeople': 'Smileys & People',
  'Emoji.AnimalsAndNature': 'Animals & Nature',
  'Emoji.FoodAndDrink': 'Food & Drink',
  'Emoji.ActivityAndSport': 'Activity & Sport',
  'Emoji.TravelAndPlaces': 'Travel & Places',
  'Emoji.Objects': 'Objects',
  // "Emoji.Symbols": "Symbols",
  'Emoji.Flags': 'Flags',
  'Error.AnError': 'An error occurred. Please try again later.',
  'ExportedInvitation.Status.Revoked': 'revoked',
  'ExportedInvitation.Status.Expired': 'expired',
  'FileSize.B': '%@ B',
  'FileSize.KB': '%@ KB',
  'FileSize.MB': '%@ MB',
  'FileSize.GB': '%@ GB',
  'InstalledStickers.LoopAnimated': 'Loop Animated Stickers',
  'InviteLink.JoinedNew': {
    'other_value': '%d joined'
  },
  'InviteLink.JoinedRevoked': 'no one joined',
  'InviteLink.Sticker.TimeLeft': 'expires in %@',
  'LastSeen.HoursAgo': {
    'one_value': 'last seen %d hour ago',
    'other_value': 'last seen %d hours ago'
  },
  'Login.Register.LastName.Placeholder': 'Last Name',
  'LiteMode.Title': 'Power Saving',
  'LiteMode.Key.emoji.Title': 'Emoji Animations',
  'LiteMode.Key.gif.Title': 'Autoplay GIFs',
  'LiteMode.Key.video.Title': 'Autoplay Videos',
  'LiteMode.Key.stickers.Title': 'Sticker Animations',
  'LiteMode.Key.animations.Title': 'Interface Animations',
  // 'LiteMode.Key.emoji.Info': 'Loop animated emoji in messages, reactions and statuses.',
  // 'LiteMode.Key.gif.Info': 'Autoplay and loop GIFs in chats and in the keyboard.',
  // 'LiteMode.Key.video.Info': 'Autoplay and loop videos and video messages in chats.',
  // 'LiteMode.Key.stickers.Info': 'Loop animated stickers, in chats and in the keyboard.',
  // 'LiteMode.Key.animations.Info': 'Other animations that make Telegram look amazing.',
  'LiteMode.Info': 'Reduce all power-intensive animations and improve performance.',
  'LiteMode.EnableText': 'Power Saving Mode',
  'LiteMode.DisableAlert': 'Disable Power Saving Mode',
  'ManageLinks.Admin.Permanent.Desc': '**%1$@** can see this link and use it to invite new members to **%2$@**.',
  'ManageLinks.DeleteAll.Confirm': 'Are you sure you want to delete all revoked links?',
  'Message.Context.Select': 'Select',
  'Message.Context.Pin': 'Pin',
  'Message.Context.Unpin': 'Unpin',
  'Message.Context.Goto': 'Show in chat',
  'Message.ReplyActionButtonShowReceipt': 'Show Receipt',
  'MessageTimer.ShortMinutes': '%@m',
  'MessageTimer.ShortHours': '%@h',
  'MessageContext.CopyMessageLink1': 'Copy Message Link',
  'Modal.Send': 'Send',
  'NewContact.Exception.ShareMyPhoneNumber': 'Share My Phone Number',
  'NewContact.Exception.ShareMyPhoneNumber.Desc': 'You can make your phone visible to %@.',
  'NewPoll.Anonymous': 'Anonymous Voting',
  'NewPoll.Explanation.Placeholder': 'Add a Comment (Optional)',
  'NewPoll.OptionsAddOption': 'Add an Option',
  'NewPoll.MultipleChoice': 'Multiple Answers',
  'NewPoll.Quiz': 'Quiz Mode',
  'Notification.Contact.Reacted': '%1$@ to your "%2$@"',
  // "Notification.Group.Reacted": "%1$@: %2$@ to your "%3$@"",
  'Payments.Recurrent.Accept': 'I accept [Terms of Service]() of **%@**.',
  'Peer.Activity.User.PlayingGame': 'playing a game',
  'Peer.Activity.User.TypingText': 'typing',
  'Peer.Activity.User.SendingPhoto': 'sending a photo',
  'Peer.Activity.User.RecordingVideo': 'recording video',
  'Peer.Activity.User.SendingVideo': 'sending a video',
  'Peer.Activity.User.RecordingAudio': 'recording voice',
  'Peer.Activity.User.SendingFile': 'sending file',
  'Peer.Activity.User.ChoosingSticker': 'choosing a sticker',
  'Peer.Activity.User.EnjoyingAnimations': 'watching %@',
  'Peer.Activity.Chat.PlayingGame': '%@ is playing a game',
  'Peer.Activity.Chat.TypingText': '%@ is typing',
  'Peer.Activity.Chat.SendingPhoto': '%@ is sending a photo',
  'Peer.Activity.Chat.RecordingVideo': '%@ is recording video',
  'Peer.Activity.Chat.SendingVideo': '%@ is sending a video',
  'Peer.Activity.Chat.RecordingAudio': '%@ is recording voice',
  'Peer.Activity.Chat.SendingFile': '%@ is sending a file',
  'Peer.Activity.Chat.ChoosingSticker': '%@ is choosing a sticker',
  'Peer.Activity.Chat.EnjoyingAnimations': '%@ is watching %@',
  'Peer.Activity.Chat.Multi.PlayingGame1': '%@ and %d others are playing a game',
  'Peer.Activity.Chat.Multi.TypingText1': '%@ and %d others are typing',
  'Peer.Activity.Chat.Multi.SendingPhoto1': '%@ and %d others are sending photos',
  'Peer.Activity.Chat.Multi.RecordingVideo1': '%@ and %d others are recording video',
  'Peer.Activity.Chat.Multi.SendingVideo1': '%@ and %d others are sending videos',
  'Peer.Activity.Chat.Multi.RecordingAudio1': '%@ and %d others are recording voice',
  // "Peer.Activity.Chat.Multi.SendingAudio1": "%@ and %d others are sending audio",
  'Peer.Activity.Chat.Multi.SendingFile1': '%@ and %d others are sending files',
  'Peer.Activity.Chat.Multi.ChoosingSticker1': '%@ and %d others are choosing stickers',
  'Peer.ServiceNotifications': 'service notifications',
  'Peer.RepliesNotifications': 'Reply Notifications',
  'Peer.Status.justNow': 'last seen just now',
  'Peer.Status.Today': 'today',
  'Peer.Status.Yesterday': 'yesterday',
  'Peer.Status.LastSeenAt': 'last seen %@ at %@',
  'Peer.Status.minAgo': {
    'one_value': 'last seen %d minute ago',
    'other_value': 'last seen %d minutes ago'
  },
  'Peer.Status.Member': {
    'one_value': '%d member',
    'other_value': '%d members'
  },
  'Peer.Status.Subscribers': {
    'one_value': '%d subscriber',
    'other_value': '%d subscribers'
  },
  'PeerInfo.Administrators': 'Administrators',
  'PeerInfo.DeleteChannel': 'Delete Channel',
  'PeerInfo.Discussion': 'Discussion',
  'PeerInfo.Discussion.Add': 'Add',
  'PeerInfo.SharedMedia': 'Shared Media',
  'PeerInfo.Subscribers': 'Subscribers',
  'PeerInfo.DeleteContact': 'Delete Contact',
  // "PeerInfo.Confirm.RemovePeer": "Remove %@ from the group?",
  'PeerInfo.Action.VoiceChat': 'Video Chat',
  'PeerInfo.Action.LiveStream': 'Live Stream',
  'PeerInfo.Phone.AnonymousInfo': 'This number is not tied to a SIM card and was acquired on [Fragment]().',
  'PeerInfo.SetAboutDescription': 'You can provide an optional description for your group.',
  'PeerMedia.Members': 'Members',
  'PollResults.Title.Poll': 'Poll Results',
  'PollResults.Title.Quiz': 'Quiz Results',
  'PollResults.LoadMore': {
    'other_value': 'Show More (%d)'
  },
  // "PeerInfo.Confirm.DeleteGroupConfirmation": "Wait! Deleting this group will remove all members and all messages will be lost. Delete the group anyway?",
  'Preview.Dragging.AddItems': {
    'one_value': 'Add Item',
    'other_value': 'Add Items'
  },
  'PreviewSender.CaptionPlaceholder': 'Add a caption...',
  'PreviewSender.CompressFile': 'Send compressed',
  'PreviewSender.SendFile': {
    'one_value': 'Send File',
    'other_value': 'Send %d Files'
  },
  'PreviewSender.SendPhoto': {
    'one_value': 'Send Photo',
    'other_value': 'Send %d Photos'
  },
  'PreviewSender.SendVideo': {
    'one_value': 'Send Video',
    'other_value': 'Send %d Videos'
  },
  'PrivacyAndSecurity.Item.On': 'On',
  'PrivacyAndSecurity.Item.Off': 'Off',
  'PrivacyAndSecurity.SensitiveText': 'Disable filtering',
  'PrivacyAndSecurity.SensitiveDesc': 'Display sensitive media in public channels on all your Telegram devices.',
  'PrivacySettings.VoiceCalls': 'Calls',
  'PrivacySettings.Forwards': 'Forwarded Messages',
  'PrivacySettings.Groups': 'Groups and Channels',
  'PrivacySettingsController.AddUsers': 'Add Users',
  'PrivacySettingsController.GroupDescription': 'You can restrict who can add you to groups and channels with granular precision.',
  'PrivacySettingsController.Forwards.CustomHelp': 'You can restrict who can add a link to your account when forwarding your messages.',
  'PrivacySettingsController.P2p.Desc': 'Disabling peer-to-peer will relay all calls through Telegram servers to avoid revealing your IP address, but may slightly decrease audio and video quality.',
  'PrivacySettingsController.PhoneCallDescription': 'You can restrict who can call you with granular precision.',
  'PrivacySettingsController.ProfilePhoto.CustomHelp': 'You can restrict who can see your profile photo with granular precision.',
  'PrivacySettingsController.LastSeenDescription': 'You won\'t see Last Seen or Online statuses for people with whom you don\'t share yours. Approximate times will be shown instead (recently, within a week, within a month).',
  'PrivacySettingsController.PeerInfo': 'You can add users or entire groups as exceptions that will override the settings above.',
  'PrivacySettingsController.Everbody': 'Everybody',
  'PrivacySettingsController.MyContacts': 'My Contacts',
  'PrivacySettingsController.Nobody': 'Nobody',
  'PrivacySettingsController.NeverShare': 'Never Share With',
  'PrivacySettingsController.AlwaysShare': 'Always Share With',
  'PrivacySettingsController.NeverAllow': 'Never Allow',
  'PrivacySettingsController.AlwaysAllow': 'Always Allow',
  'PrivacySettingsController.UserCount': {
    'one_value': '%d user',
    'other_value': '%d users'
  },
  'RecentSessions.Error.FreshReset': 'For security reasons, you can\'t terminate older sessions from a device that you\'ve just connected. Please use an earlier connection or wait for a few hours.',
  'RequestJoin.Button': 'Request to Join',
  'RequestJoin.List.SearchEmpty': 'There were no results for "%@".\nTry a new search.',
  'Stickers.SearchAdd': 'Add',
  'Stickers.SearchAdded': 'Added',
  'Stickers.SuggestStickers': 'Suggest Stickers by Emoji',
  'ShareModal.Search.Placeholder': 'Share to...',
  'ShareModal.Search.ForwardPlaceholder': 'Forward to...',
  'Telegram.GeneralSettingsViewController': 'General Settings',
  'Telegram.InstalledStickerPacksController': 'Stickers',
  'Telegram.NotificationSettingsViewController': 'Notifications',
  'Telegram.LanguageViewController': 'Language',
  'Text.CopyLabel_About': 'Copy About',
  'Text.CopyLabel_Bio': 'Copy Bio',
  'Text.CopyLabel_PhoneNumber': 'Copy Phone Number',
  'Text.CopyLabel_Username': 'Copy Username',
  'Text.CopyLabel_ShareLink': 'Copy Share Link',
  'GeneralSettings.BigEmoji': 'Large Emoji',
  'GeneralSettings.EmojiPrediction': 'Suggest Emoji',
  'GroupPermission.Delete': 'Delete Exception',
  'Search.Confirm.ClearHistory': 'Are you sure you want to clear your search history?',
  'SecureId.Identity.Placeholder.ExpiryDate': 'Expiry Date',
  'Separator.ShowMore': 'show more',
  'Separator.ShowLess': 'show less',
  'ScheduleController.at': 'at',
  'Schedule.SendToday': 'Send today at %@',
  'Schedule.SendDate': 'Send on %@ at %@',
  'Schedule.SendWhenOnline': 'Send When Online',
  'Story.Tooltip.MessageSent': 'Message Sent.',
  'Sticker.Premium.Click.Info': 'This pack contains premium stickers like this one. [View Pack]()',
  'Stickers.Recent': 'Recent',
  // "Stickers.Favorite": "Favorite",
  'StickerSet.DontExist': 'Sorry, this sticker set doesn\'t seem to exist.',
  'Text.Context.Copy.Username': 'Copy Username',
  'Text.Context.Copy.Hashtag': 'Copy Hashtag',
  'Time.TomorrowAt': 'tomorrow at %@',
  'TwoStepAuth.SetPasswordHelp': 'You can set a password that will be required when you log in on a new device in addition to the code you get in the SMS.',
  'TwoStepAuth.GenericHelp': 'You have enabled Two-Step verification.\nYou\'ll need the password you set up here to log in to your Telegram account.',
  'TwoStepAuth.ChangePassword': 'Change Password',
  'TwoStepAuth.RemovePassword': 'Disable Password',
  'TwoStepAuth.SetupEmail': 'Set Recovery Email',
  'TwoStepAuth.ChangeEmail': 'Change Recovery Email',
  'TwoStepAuth.ConfirmEmailCodeDesc': 'Please enter the code we\'ve just emailed to %@.',
  'TwoStepAuth.RecoveryTitle': 'Email Code',
  'TwoStepAuth.RecoveryCode': 'Code',
  'TwoStepAuth.RecoveryCodeInvalid': 'Invalid code. Please try again.',
  'TwoStepAuth.RecoveryCodeExpired': 'Code Expired',
  'TwoStepAuth.SetupHintTitle': 'Password Hint',
  'TwoStepAuth.SetupHintPlaceholder': 'Hint',
  'VoiceChat.Chat.StartNew': 'Video chat ended. Start a new one?',
  'VoiceChat.Chat.StartNew.OK': 'Start',
  'VoiceChat.Chat.Ended': 'Video chat ended.',
  'VoiceChat.Invite.InviteMembers': 'Invite members',
  'VoiceChat.Status.Connecting': 'Connecting...',
  'VoiceChat.Status.Members': {
    'one_value': '%d participant',
    'other_value': '%d participants'
  },
  'VoiceChat.Status.MutedForYou': 'muted for you',
  'VoiceChat.Status.Speaking': 'speaking',
  'VoiceChat.Status.Listening': 'listening',
  'VoiceChat.Status.WantsSpeak': 'wants to speak',
  'VoiceChat.Status.Muted': 'muted',
  'VoiceChat.Status.You': 'This is you',
  'VoiceChat.Video.Stream.Video': 'video',
  'VoiceChat.Video.Stream.Screencast': 'screen',
  'VoiceChat.Video.Stream.More': 'more',
  'VoiceChat.Leave': 'Leave',
  'VoiceChat.End.Title': 'Leave video chat',
  'VoiceChat.End.Text': 'Are you sure you want to leave this video chat?',
  'VoiceChat.End.Third': 'End Video Chat',
  'VoiceChat.End.OK': 'Leave',
  'VoiceChat.MutePeer': 'Mute',
  'VoiceChat.UnmutePeer': 'Allow To Speak',
  'VoiceChat.RemovePeer': 'Remove',
  'VoiceChat.OpenProfile': 'Open Profile',
  'VoiceChat.MuteForMe': 'Mute For Me',
  'VoiceChat.UnmuteForMe': 'Unmute For Me',
  'VoiceChat.RemovePeer.Confirm.Channel': 'Do you want to remove %1$@ from the channel?',
  'VoiceChat.RemovePeer.Confirm': 'Are you sure you want to remove %1$@ from the group?',
  'VoiceChat.RemovePeer.Confirm.OK': 'Remove',
  'WebApp.AttachRemove.Success': '"%@" removed from your attachment menu.',
  'WebApp.InstallBot': 'Install Bot'
};

export default lang;
